<template>
  <div>
    <div class="md-layout">
      <div
        style="position: absolute; top: 50%; left: 50%; width: 10%; z-index: 2"
        v-show="loading == true"
      >
        <md-progress-spinner
          :md-stroke="8"
          :md-diameter="65"
          md-mode="indeterminate"
        ></md-progress-spinner>
        <div v-if="loading" class="bg-overlay-unset" style="z-index: 15"></div>
      </div>
      <div class="loading-overlay-popup" v-if="loadingPopup">
        <md-progress-spinner
          class="overlay-popup"
          md-mode="indeterminate"
          :md-stroke="8"
          :md-diameter="65"
        ></md-progress-spinner>
        <div v-if="loadingPopup" class="bg-overlay-unset" style="z-index: 15"></div>
      </div>

      <div
        v-if="valueTab != 'WARNING'"
        class="
          md-layout-item md-large-size-20 md-medium-size-20 md-small-size-25
        "
      >
        <div class="pricing-head mktops-subheader-filter">
          <md-field class="box">
            <!-- <md-select v-model="slcSearch" id="select-price-unit" @md-selected="onChangeSearch('select')"> -->
            <md-select v-model="slcSearch" id="select-price-unit">
              <md-option
                v-for="(item, index) in status"
                :key="index"
                :value="index"
                >{{ item }}</md-option
              >
            </md-select>
          </md-field>
        </div>
      </div>
      <div
        v-if="valueTab == 'WARNING'"
        class="
          md-layout-item md-large-size-20 md-medium-size-20 md-small-size-25
        "
      >
        <div class="pricing-head mktops-subheader-filter">
          <md-field v-if="valueTab == 'WARNING'" class="box">
            <md-select
              v-model="optWarning"
              @input="selectWarning(optWarning)"
              id="select-warning-type"
            >
              <md-option
                v-for="(item, index) in warningType"
                :key="index"
                :value="index"
                >{{ item }}</md-option
              >
            </md-select>
          </md-field>
        </div>
      </div>
      <div
        :class="
          valueTab != 'WARNING'
            ? 'md-layout-item md-large-size-35 md-medium-size-35 md-small-size-35'
            : 'md-layout-item md-large-size-35 md-medium-size-35 md-small-size-50'
        "
      >
        <md-field class="md-search-box">
          <!-- <i class="md-icon material-icons">search</i> -->
          <!-- <i class="md-icon material-icons" style="margin-top: 6px; cursor: pointer;" title="Click to change search" @click="selectSearch">find_replace</i> -->
          <i
            class="md-icon material-icons"
            style="margin-top: 6px; cursor: pointer"
            :title="titleSearch"
            @click="selectSearch"
            >find_replace</i
          >
          <md-input
            type="text"
            :placeholder="placeholderSearch"
            v-model="searchList"
            style="padding-right: 8px"
            @input="onChangeSearch('input')"
          ></md-input>
          <!-- <i class="md-icon material-icons" style="margin-right: 8px; margin-left: 5px; margin-top: 6px; cursor: pointer;" @click="selectSearch">autorenew</i> -->
        </md-field>
        <md-button
          class="md-icon-button"
          title="Add Filters"
          @click="filterData"
        >
          <md-icon>filter_list</md-icon>
        </md-button>
      </div>
      <div
        :class="
          valueTab != 'WARNING'
            ? 'md-layout-item md-large-size-45 md-medium-size-45 md-small-size-40 layout-flex-end'
            : 'md-layout-item md-large-size-45 md-medium-size-45 md-small-size-50 layout-flex-end'
        "
        style="padding-right: 20px"
      >
        <div>
          <md-button
            v-show="showExportBtn"
            class="md-raised md-primary"
            style="background-color: #d84710; height: 32px"
            @click="export_excel"
          >
            Excel format
          </md-button>
        </div>
        <div>
          <md-button
            v-show="showTemplateUpdate || showImportBtn"
            class="md-raised md-primary -export-selected"
            @click="export_csv"
          >
            Template update price
            <!-- <input style="display: none;"> -->
          </md-button>
        </div>
        <div>
          <!-- <md-button ref="importBtn" v-if="showImportBtn" class="md-raised md-primary -import" @click="trigger_upload"> -->
          <md-button
            ref="importBtn"
            v-if="showTemplateUpdate || showImportBtn"
            class="md-raised md-primary -import"
            @click="import_file"
          >
            <i class="md-icon material-icons">add</i>IMPORT
          </md-button>
          <!-- <input
            type="file"
            ref="fileInput"
            class="import-file"
            :accept="accept"
            @change="browseFile"
          >-->
        </div>
      </div>
    </div>

    <div class="md-layout filter-chips" v-if="vChipsFilter.length > 0">
      <div v-for="(items, idx) in vChipsFilter" :key="items.keyId">
        <span class="tab-chip -primary">
          {{ items.id }} - {{ items.name }}
          <span class="tab-chip -delete" @click="deleteFilter(items, idx)">
            <i class="material-icons">close</i>
          </span>
        </span>
      </div>
    </div>
    <div id="table-pricing-list">
      <!--<div id="divHeadList" :style="{'width':valueTab == 'WARNING' ? '97.8%' : '99.3%'}">-->
      <div id="divHeadList" :style="setWidthHead(valueTab)">
        <!-- :style="{ width: valueTab == 'WARNING' ? '99.8%' : '96.4%' }" -->
        <div :style="{ width: '6.5%' }">Code</div>
        <!-- <div :style="{'width':valueTab == 'ALL' ? '13%' : '8.5%'}">Name</div> -->
        <div v-if="valueTab == 'ALL' && slcSearch == 1" style="width: 14.5%">
          Name
        </div>
        <div v-else-if="valueTab == 'ALL' && slcSearch == 0" style="width: 20%">
          Name
        </div>
        <div v-if="valueTab == 'UPCOMING' && slcSearch == 1" style="width: 16%">
          Name
        </div>
        <!--<div v-else-if="(valueTab == 'UPCOMING' && slcSearch == 0)" style="width: 26.40%">Name</div>-->
        <div
          v-else-if="valueTab == 'UPCOMING' && slcSearch == 0"
          style="width: 21.5%"
        >
          Name
        </div>
        <div v-if="valueTab == 'WARNING'" style="width: 21.5%">Name</div>

        <div
          v-if="(valueTab == 'ALL' || valueTab == 'UPCOMING') && slcSearch == 1"
          style="width: 5.5%"
        >
          Unit
        </div>
        <div style="width: 7.2%" class="-text-right">Cost</div>
        <div
          style="width: 7.2%"
          class="-text-right"
          title="ราคาส่ง (ไม่รวม VAT)"
        >
          A3
        </div>
        <div
          style="width: 7.2%"
          class="-text-right"
          title="ราคาปลีก (ไม่รวม VAT)"
        >
          A2
        </div>
        <div style="width: 7.2%" class="-text-right" title="ราคาปลีก (รวม VAT)">
          A1
        </div>
        <div
          style="width: 7.2%"
          class="-text-right"
          title="ราคาร้านคู่ค้า3 (ไม่รวม Vat)"
        >
          C3
        </div>
        <div
          style="width: 7.2%"
          class="-text-right"
          title="ราคาร้านคู่ค้า2 (ไม่รวม Vat)"
        >
          C2
        </div>
        <div
          style="width: 7.2%"
          class="-text-right"
          title="ราคาร้านคู่ค้า (ไม่รวม Vat)"
        >
          C1
        </div>
        <div
          style="width: 7.2%"
          class="-text-right"
          title="ราคาขายส่ง หักส่วนลดสูงสุด"
        >
          C0
        </div>
        <div
          style="width: 7.2%"
          class="-text-right"
          title="ราคาปลีกแนะนำ (รวมVAT)"
        >
          SR
        </div>
        <div
          style="width: 7.2%"
          class="-text-right"
          title="ราคาปลีกแนะนำ (ไม่รวมVAT)"
        >
          SS
        </div>
        <!--            <div style="width: 10.4%" class="-text-center" v-if="valueTab == 'ALL'">Effective Date</div>
            <div style="width: 9.5%" class="-text-center" v-else-if="valueTab == 'WARNING'">Effective Date</div>-->
        <!-- <div style="width: 7.2%" class="-text-right">B1</div>
            <div style="width: 7.2%" class="-text-right">B2</div> -->
        <!--            <div v-if="(valueTab == 'WARNING')" style="width: 8.5%;" class="-text-center">Warning</div>
            <div v-else-if="(valueTab == 'UPCOMING')" style="width: 9.5%;" class="-text-center">Effective Date</div>-->
        <div
          style="width: 2.5%"
          v-if="valueTab != 'WARNING' && valueTab != 'UPCOMING'"
        ></div>
      </div>
      <div
        id="divBodyList"
        :class="vChipsFilter.length > 0 ? 'de-height' : 'cal-height'"
        @scroll="handleScroll"
      >
        <div
          style="position: absolute; top: 50%; left: 50%; width: 10%"
          v-show="loadData == true || loadExport == true"
        >
          <md-progress-spinner
            :md-stroke="8"
            :md-diameter="65"
            md-mode="indeterminate"
          ></md-progress-spinner>
          <div v-if="loadData == true || loadExport == true" class="bg-overlay-unset" style="z-index: 15"></div>
        </div>
        <!-- <div :class="'row-bg-gray'" v-for="(item, rIndex) in tbPricingList" :key="rIndex"> -->
        <div
          :class="
            rIndex % 2 == 1 ? 'row-bg-gray' : 'main-row-bg-gray row-bg-gray'
          "
          v-for="(item, rIndex) in tbPricingList"
          :key="rIndex"
        >
          <div id="mainRows">
            <div :style="{ width: '6.5%' }">
              <div style="font-size: 13px; padding-left: 2px">
                {{ item.iprod }}
              </div>
              <!-- <div v-if="(valueTab == 'WARNING' || slcSearch == 0)" style="font-size: 11px;font-style: italic;font-family:kanit">{{item.stock_um_title}}</div> -->
              <div
                v-if="valueTab == 'WARNING' || slcSearch == 0"
                style="font-size: 11px; font-style: italic; font-family: kanit"
              >
                {{ item.selling_um_title }} ({{ item.selling_um_conv }})
              </div>
            </div>

            <!-- *** START COLUMN NAME *** -->
            <!-- <div :style="{'width':valueTab == 'WARNING' ? '14.5%' : '13%', 'font-size' :'14px', 'font-weight': ' 300'}" class="nowrap-title">
                        <span :title="item.title_th">{{ item.title_th }}</span>
                    </div> -->
            <div
              v-if="valueTab == 'ALL' && slcSearch == 1"
              style="width: 14.5%; font-size: 14px; font-weight: 300"
              class="nowrap-title"
            >
              <span :title="item.title_th">{{ item.title_th }}</span>
            </div>
            <div
              v-else-if="valueTab == 'ALL' && slcSearch == 0"
              style="width: 20%; font-size: 14px; font-weight: 300"
              class="nowrap-title"
            >
              <span :title="item.title_th">{{ item.title_th }}</span>
            </div>
            <div
              v-if="valueTab == 'UPCOMING' && slcSearch == 1"
              style="width: 16%; font-size: 14px; font-weight: 300"
              class="nowrap-title"
            >
              <span :title="item.title_th">{{ item.title_th }}</span>
            </div>
            <div
              v-else-if="valueTab == 'UPCOMING' && slcSearch == 0"
              style="width: 21.5%; font-size: 14px; font-weight: 300"
              class="nowrap-title"
            >
              <span :title="item.title_th">{{ item.title_th }}</span>
            </div>
            <div
              v-if="valueTab == 'WARNING'"
              style="width: 21.5%; font-size: 14px; font-weight: 300"
              class="nowrap-title"
            >
              <span :title="item.title_th">{{ item.title_th }}</span>
            </div>
            <!-- *** END COLUMN NAME *** -->

            <div
              v-if="
                (valueTab == 'ALL' || valueTab == 'UPCOMING') && slcSearch == 1
              "
              style="width: 5.5%; font-weight: 300; font-family: kanit"
            >
              <!-- <div style="font-size: 14px; padding-left: 0px; padding-right: 0px;">{{item.stock_um_title}}</div>
                        <div v-if="(item.selling_um_conv)" style="font-size: 12px; padding-left: 0px; padding-right: 0px;">{{item.selling_um_title}} ({{item.selling_um_conv}})</div>
                        <div v-else style="font-size: 12px; padding-left: 0px; padding-right: 0px;">{{item.selling_um_title}}</div> -->
              <div
                v-if="item.selling_um_conv"
                style="font-size: 14px; padding-left: 0px; padding-right: 0px"
              >
                {{ item.selling_um_title }} ({{ item.selling_um_conv }})
              </div>
              <div
                v-else
                style="font-size: 14px; padding-left: 0px; padding-right: 0px"
              >
                {{ item.selling_um_title }}
              </div>
              <div
                style="font-size: 12px; padding-left: 0px; padding-right: 0px"
              >
                {{ item.stock_um_title }}
              </div>
            </div>

            <!-- <div style="width: 7.2%;" class="-text-right">
                        {{showPoint(item.cost , 'front')}}
                        <span style="font-size:11px">{{showPoint(item.cost, 'behind')}}</span>
                    </div> -->
            <div style="width: 7.2%" class="-text-right">
              <!-- <div v-if="(item.cost && item.cost != '')">
                            {{showPoint(item.cost , 'front')}}
                            <span style="font-size:11px">{{showPoint(item.cost, 'behind')}}</span>
                        </div>
                        <div v-if="(slcSearch == 1 && (valueTab == 'ALL' || valueTab == 'UPCOMING'))" class="-percent">{{formatNumber(item.cost_conv , 2)}}</div> -->
              <div v-if="item.cost_conv && item.cost_conv != ''">
                {{ showPoint(item.cost_conv, "front") }}
                <span style="font-size: 11px">{{
                  showPoint(item.cost_conv, "behind")
                }}</span>
              </div>
              <div
                v-if="
                  slcSearch == 1 &&
                  (valueTab == 'ALL' || valueTab == 'UPCOMING')
                "
                class="-percent"
              >
                {{ formatNumber(item.cost, 2) }}
              </div>
            </div>
            <!-- <div style="width: 7.2%" class="-text-right">
                        <div v-if="(item.price && item.price.price_a3 != '')">
                            {{showPoint(item.price.price_a3, 'front')}}
                            <span style="font-size:11px">{{showPoint(item.price.price_a3, 'behind')}}</span>
                        </div>
                        <div v-else style="visibility: hidden;">-</div>
                        <div v-if="(slcSearch == 1 && (valueTab == 'ALL' || valueTab == 'UPCOMING'))" :class="(item.selling_conv_price.selling_conv_price_a3 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.selling_conv_price.selling_conv_price_a3 , 2)}}</div>
                    </div> -->
            <div style="width: 7.2%" class="-text-right">
              <div
                v-if="
                  item.selling_conv_price &&
                  item.selling_conv_price.selling_conv_price_a3 != ''
                "
              >
                {{
                  showPoint(
                    item.selling_conv_price.selling_conv_price_a3,
                    "front"
                  )
                }}
                <span style="font-size: 11px">{{
                  showPoint(
                    item.selling_conv_price.selling_conv_price_a3,
                    "behind"
                  )
                }}</span>
              </div>
              <div v-else style="visibility: hidden">-</div>
              <div
                v-if="
                  slcSearch == 1 &&
                  (valueTab == 'ALL' || valueTab == 'UPCOMING')
                "
                :class="item.price.price_a3 < 0 ? '-bgred' : '-percent'"
              >
                {{ formatNumber(item.price.price_a3, 2) }}
              </div>
            </div>
            <!-- <div style="width: 7.2%" class="-text-right">
                        <div v-if="(item.price && item.price.price_a2 != '')">
                            {{showPoint(item.price.price_a2, 'front')}}
                            <span style="font-size:11px">{{showPoint(item.price.price_a2, 'behind')}}</span>
                        </div>
                        <div v-else style="visibility: hidden;">-</div>
                        <div v-if="(slcSearch == 0 || valueTab == 'WARNING') && valueTab != 'UPCOMING'" :class="(item.percent.percent_a2 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.percent.percent_a2 , 2)}}%</div>
                        <div v-else-if="(slcSearch == 1 || valueTab != 'UPCOMING')" :class="(item.selling_conv_price.selling_conv_price_a2 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.selling_conv_price.selling_conv_price_a2 , 2)}}</div>
                    </div> -->
            <div style="width: 7.2%" class="-text-right">
              <div
                v-if="
                  item.selling_conv_price &&
                  item.selling_conv_price.selling_conv_price_a2 != ''
                "
              >
                {{
                  showPoint(
                    item.selling_conv_price.selling_conv_price_a2,
                    "front"
                  )
                }}
                <span style="font-size: 11px">{{
                  showPoint(
                    item.selling_conv_price.selling_conv_price_a2,
                    "behind"
                  )
                }}</span>
              </div>
              <div v-else style="visibility: hidden">-</div>
              <div
                v-if="
                  (slcSearch == 0 || valueTab == 'WARNING') &&
                  valueTab != 'UPCOMING'
                "
                :class="item.percent.percent_a2 < 0 ? '-bgred' : '-percent'"
              >
                {{ formatNumber(item.percent.percent_a2, 2) }}%
              </div>
              <div
                v-else-if="slcSearch == 1 || valueTab != 'UPCOMING'"
                :class="item.price.price_a2 < 0 ? '-bgred' : '-percent'"
              >
                {{ formatNumber(item.price.price_a2, 2) }}
              </div>
            </div>

            <!-- <div style="width: 7.2%" class="-text-right">
                        <div v-if="(item.price && item.price.price_a1 != '')">
                            {{showPoint(item.price.price_a1, 'front')}}
                            <span style="font-size:11px">{{showPoint(item.price.price_a1, 'behind')}}</span>
                        </div>
                        <div v-else style="visibility: hidden;">-</div>
                        <div v-if="(slcSearch == 0  || valueTab == 'WARNING') && valueTab != 'UPCOMING'" :class="(item.percent.percent_a1 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.percent.percent_a1 , 2)}}%</div>
                        <div v-else-if="(slcSearch == 1 || valueTab != 'UPCOMING')" :class="(item.selling_conv_price.selling_conv_price_a1 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.selling_conv_price.selling_conv_price_a1 , 2)}}</div>
                    </div> -->
            <div style="width: 7.2%" class="-text-right">
              <div
                v-if="
                  item.selling_conv_price &&
                  item.selling_conv_price.selling_conv_price_a1 != ''
                "
              >
                {{
                  showPoint(
                    item.selling_conv_price.selling_conv_price_a1,
                    "front"
                  )
                }}
                <span style="font-size: 11px">{{
                  showPoint(
                    item.selling_conv_price.selling_conv_price_a1,
                    "behind"
                  )
                }}</span>
              </div>
              <div v-else style="visibility: hidden">-</div>
              <div
                v-if="
                  (slcSearch == 0 || valueTab == 'WARNING') &&
                  valueTab != 'UPCOMING'
                "
                :class="item.percent.percent_a1 < 0 ? '-bgred' : '-percent'"
              >
                {{ formatNumber(item.percent.percent_a1, 2) }}%
              </div>
              <div
                v-else-if="slcSearch == 1 || valueTab != 'UPCOMING'"
                :class="item.price.price_a1 < 0 ? '-bgred' : '-percent'"
              >
                {{ formatNumber(item.price.price_a1, 2) }}
              </div>
            </div>
            <!-- <div style="width: 7.2%" class="-text-right">
                        <div v-if="(item.price && item.price.price_c3 != '')">
                            {{showPoint(item.price.price_c3, 'front')}}
                            <span style="font-size:11px">{{showPoint(item.price.price_c3, 'behind')}}</span>
                        </div>
                        <div v-else style="visibility: hidden;">-</div>
                        <div v-if="(slcSearch == 0 || valueTab == 'WARNING') && valueTab != 'UPCOMING'" :class="(item.percent.percent_c3 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.percent.percent_c3 , 2)}}%</div>
                        <div v-else-if="(slcSearch == 1 || valueTab != 'UPCOMING')" :class="(item.selling_conv_price.selling_conv_price_c3 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.selling_conv_price.selling_conv_price_c3 , 2)}}</div>
                    </div> -->
            <div style="width: 7.2%" class="-text-right">
              <div
                v-if="
                  item.selling_conv_price &&
                  item.selling_conv_price.selling_conv_price_c3 != ''
                "
              >
                {{
                  showPoint(
                    item.selling_conv_price.selling_conv_price_c3,
                    "front"
                  )
                }}
                <span style="font-size: 11px">{{
                  showPoint(
                    item.selling_conv_price.selling_conv_price_c3,
                    "behind"
                  )
                }}</span>
              </div>
              <div v-else style="visibility: hidden">-</div>
              <div
                v-if="
                  (slcSearch == 0 || valueTab == 'WARNING') &&
                  valueTab != 'UPCOMING'
                "
                :class="item.percent.percent_c3 < 0 ? '-bgred' : '-percent'"
              >
                {{ formatNumber(item.percent.percent_c3, 2) }}%
              </div>
              <div
                v-else-if="slcSearch == 1 || valueTab != 'UPCOMING'"
                :class="item.price.price_c3 < 0 ? '-bgred' : '-percent'"
              >
                {{ formatNumber(item.price.price_c3, 2) }}
              </div>
            </div>
            <div style="width: 7.2%" class="-text-right">
              <div
                v-if="
                  item.selling_conv_price &&
                  item.selling_conv_price.selling_conv_price_c2 != ''
                "
              >
                {{
                  showPoint(
                    item.selling_conv_price.selling_conv_price_c2,
                    "front"
                  )
                }}
                <span style="font-size: 11px">{{
                  showPoint(
                    item.selling_conv_price.selling_conv_price_c2,
                    "behind"
                  )
                }}</span>
              </div>
              <div v-else style="visibility: hidden">-</div>
              <div
                v-if="
                  (slcSearch == 0 || valueTab == 'WARNING') &&
                  valueTab != 'UPCOMING'
                "
                :class="item.percent.percent_c2 < 0 ? '-bgred' : '-percent'"
              >
                {{ formatNumber(item.percent.percent_c2, 2) }}%
              </div>
              <div
                v-else-if="slcSearch == 1 || valueTab != 'UPCOMING'"
                :class="item.price.price_c2 < 0 ? '-bgred' : '-percent'"
              >
                {{ formatNumber(item.price.price_c2, 2) }}
              </div>
            </div>
            <div style="width: 7.2%" class="-text-right">
              <div
                v-if="
                  item.selling_conv_price &&
                  item.selling_conv_price.selling_conv_price_c1 != ''
                "
              >
                {{
                  showPoint(
                    item.selling_conv_price.selling_conv_price_c1,
                    "front"
                  )
                }}
                <span style="font-size: 11px">{{
                  showPoint(
                    item.selling_conv_price.selling_conv_price_c1,
                    "behind"
                  )
                }}</span>
              </div>
              <div v-else style="visibility: hidden">-</div>
              <div
                v-if="
                  (slcSearch == 0 || valueTab == 'WARNING') &&
                  valueTab != 'UPCOMING'
                "
                :class="item.percent.percent_c1 < 0 ? '-bgred' : '-percent'"
              >
                {{ formatNumber(item.percent.percent_c1, 2) }}%
              </div>
              <div
                v-else-if="slcSearch == 1 || valueTab != 'UPCOMING'"
                :class="item.price.price_c1 < 0 ? '-bgred' : '-percent'"
              >
                {{ formatNumber(item.price.price_c1, 2) }}
              </div>
            </div>
            <div style="width: 7.2%" class="-text-right">
              <div
                v-if="
                  item.selling_conv_price &&
                  item.selling_conv_price.selling_conv_price_c0 != ''
                "
              >
                {{
                  showPoint(
                    item.selling_conv_price.selling_conv_price_c0,
                    "front"
                  )
                }}
                <span style="font-size: 11px">{{
                  showPoint(
                    item.selling_conv_price.selling_conv_price_c0,
                    "behind"
                  )
                }}</span>
              </div>
              <div v-else style="visibility: hidden">-</div>
              <div
                v-if="
                  (slcSearch == 0 || valueTab == 'WARNING') &&
                  valueTab != 'UPCOMING'
                "
                :class="item.percent.percent_c0 < 0 ? '-bgred' : '-percent'"
              >
                {{ formatNumber(item.percent.percent_c0, 2) }}%
              </div>
              <div
                v-else-if="slcSearch == 1 || valueTab != 'UPCOMING'"
                :class="item.price.price_c0 < 0 ? '-bgred' : '-percent'"
              >
                {{ formatNumber(item.price.price_c0, 2) }}
              </div>
            </div>
            <div style="width: 7.2%" class="-text-right">
              <div
                v-if="
                  item.selling_conv_price &&
                  item.selling_conv_price.selling_conv_price_sr != ''
                "
              >
                {{
                  showPoint(
                    item.selling_conv_price.selling_conv_price_sr,
                    "front"
                  )
                }}
                <span style="font-size: 11px">{{
                  showPoint(
                    item.selling_conv_price.selling_conv_price_sr,
                    "behind"
                  )
                }}</span>
              </div>
              <div v-else style="visibility: hidden">-</div>
              <div
                v-if="
                  (slcSearch == 0 || valueTab == 'WARNING') &&
                  valueTab != 'UPCOMING'
                "
                :class="item.percent.percent_sr < 0 ? '-bgred' : '-percent'"
              >
                {{ formatNumber(item.percent.percent_sr, 2) }}%
              </div>
              <div
                v-else-if="slcSearch == 1 || valueTab != 'UPCOMING'"
                :class="item.price.price_sr < 0 ? '-bgred' : '-percent'"
              >
                {{ formatNumber(item.price.price_sr, 2) }}
              </div>
            </div>
            <div style="width: 7.2%" class="-text-right">
              <div
                v-if="
                  item.selling_conv_price &&
                  item.selling_conv_price.selling_conv_price_ss != ''
                "
              >
                {{
                  showPoint(
                    item.selling_conv_price.selling_conv_price_ss,
                    "front"
                  )
                }}
                <span style="font-size: 11px">{{
                  showPoint(
                    item.selling_conv_price.selling_conv_price_ss,
                    "behind"
                  )
                }}</span>
              </div>
              <div v-else style="visibility: hidden">-</div>
              <div
                v-if="
                  (slcSearch == 0 || valueTab == 'WARNING') &&
                  valueTab != 'UPCOMING'
                "
                :class="item.percent.percent_ss < 0 ? '-bgred' : '-percent'"
              >
                {{ formatNumber(item.percent.percent_ss, 2) }}%
              </div>
              <div
                v-else-if="slcSearch == 1 || valueTab != 'UPCOMING'"
                :class="item.price.price_ss < 0 ? '-bgred' : '-percent'"
              >
                {{ formatNumber(item.price.price_ss, 2) }}
              </div>
            </div>
            <!-- <div style="width: 7.2%" class="-text-right">
                        <div v-if="(item.price && item.price.price_b1 != '')">
                            {{showPoint(item.price.price_b1, 'front')}}
                            <span style="font-size:11px">{{showPoint(item.price.price_b1, 'behind')}}</span>
                        </div>
                        <div v-else style="visibility: hidden;">-</div>
                        <div v-if="(slcSearch == 0 || valueTab == 'WARNING')" :class="(item.percent.percent_b1 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.percent.percent_b1 , 2)}}%</div>
                        <div v-else :class="(item.selling_conv_price.selling_conv_price_b1 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.selling_conv_price.selling_conv_price_b1 , 2)}}</div>
                    </div>
                    <div style="width: 7.2%" class="-text-right">
                        <div v-if="(item.price && item.price.price_b2 != '')">
                            {{showPoint(item.price.price_b2, 'front')}}
                            <span style="font-size:11px">{{showPoint(item.price.price_b2, 'behind')}}</span>
                        </div>
                        <div v-else style="visibility: hidden;">-</div>
                        <div v-if="(slcSearch == 0 || valueTab == 'WARNING')" :class="(item.percent.percent_b2 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.percent.percent_b2 , 2)}}%</div>
                        <div v-else :class="(item.selling_conv_price.selling_conv_price_b2 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.selling_conv_price.selling_conv_price_b2 , 2)}}</div>
                    </div> -->

            <!-- <div style="width: 6.5%;font-size:11px" class="-text-center" v-if="valueTab == 'UPCOMING'">{{item.effective_date}}</div> -->
            <!--                    <div style="width: 9.5%; font-size:11px" class="-text-center" v-if="valueTab == 'UPCOMING'">{{item.effective_date}}</div>
                    <div style="width: 8.5%; font-size:11px" class="-text-center" v-else-if="valueTab == 'WARNING'">{{item.effective_date}}</div>
                    <div style="width: 10.4%; font-size:11px" class="-text-center" v-else>{{item.effective_date}}</div>-->
            <!--<div style="width: 8.5%; font-size:11px" v-if="valueTab == 'WARNING'">{{item.warning}}</div>-->
            <div
              style="width: 1.5%; margin-left: -13px; cursor: pointer"
              v-if="valueTab != 'WARNING' && valueTab != 'UPCOMING'"
              @click="openDlg(item)"
            >
              <!--<div style="width: 20px;margin-left: -13px; cursor:pointer" @click="openDlg(item)" v-if="valueTab != 'WARNING' && valueTab != 'UPCOMING'">-->
              <md-icon style="margin-left: 7px" title="Price History"
                >more_vert</md-icon
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <md-dialog
      :md-active.sync="showDialog"
      v-on="dialogClose()"
      class="pricinglist dialog-import"
      :md-click-outside-to-close="clickOutside"
      :style="{
        height: modeDialog == 'browseFile' ? '60%' : ' 80%',
        opacity: dialogConfirmSave ? '0.8' : ' unset',
        width: modeDialog == 'browseFile' ? '70%' : ' 100%',
        left: modeDialog == 'browseFile' ? '17%' : ' 10%',
        top: modeDialog == 'browseFile' ? '20%' : ' 10%',
      }"
    >
      <div :class="checkBackdrop ? 'backdrop-pricing' : ''"></div>
      <md-dialog-title v-if="modeDialog == 'browseFile'"
        >Importing Price Updates</md-dialog-title
      >
      <md-dialog-title v-else style="padding-left: 25px">
        <div class="md-layout" style="margin-bottom: 20px">
          <div class="md-layout-item md-size-10">
            <div class="-percent" style="font-size: 12px; color: #949496">
              Product Code
            </div>
            <div style="font-size: 16px; line-height: 0.8">
              {{ selectedRow.iprod }}
            </div>
          </div>
          <div class="md-layout-item md-size-75">
            <div class="-percent" style="font-size: 12px; color: #949496">
              Product Name
            </div>
            <div style="font-size: 16px; font-family: kanit; line-height: 0.8">
              {{ selectedRow.title_th }}
            </div>
          </div>
          <div
            class="md-layout-item md-size-15"
            style="text-align: right; cursor: pointer"
            @click="showDialog = false"
          >
            <md-icon>close</md-icon>
          </div>
        </div>
      </md-dialog-title>
      <div
        class="md-layout dialog-content"
        :style="{
          'padding-top': '0px',
          'padding-left': modeDialog == 'browseFile' ? '25px' : ' 20px',
        }"
      >
        <div v-if="modeDialog == 'browseFile'" style="width: 100%">
          <div class="md-layout">
            <!-- <div class="md-layout-item md-size-55"> -->
            <div class="md-layout-item md-size-20">
              <div style="font-size: 14px; padding-top: 28px">
                <!-- Please confirm the
                <b>{{ price_updates }} price</b> updates and-->
                Set an effective date
              </div>
            </div>
            <div class="md-layout-item md-size-20">
              <div class="mkt-datepicker">
                <md-datepicker
                  class
                  v-model="eff_date"
                  md-immediately
                  :md-disabled-dates="disabledDates"
                  onkeydown="return false"
                >
                  <label>Effective Date</label>
                </md-datepicker>
              </div>
            </div>
            <div
              class="md-layout-item md-size-60"
              style="padding-left: 25px; padding-top: 28px"
            >
              for the price change
            </div>
          </div>

          <!-- <div class="md-layout-item" style="margin-bottom: 35px;"> -->
          <div id="table-import-file">
            <h4 style="margin-top: 0px; margin-bottom: 0px">
              List File Import:
            </h4>
            <div id="divHeadFile">
              <div style="width: 60%; font-family: kanit; font-size: 14px">
                ชื่อ
              </div>
              <div style="width: 40%; font-family: kanit; font-size: 14px">
                แก้ไขล่าสุด
              </div>
            </div>
            <div id="divBodyFile">
              <div
                :class="
                  fileID == file.id ? 'row-bg-blue -file' : 'row-bg-gray -file'
                "
                v-for="(file, fileIndex) in listImport"
                :key="fileIndex"
              >
                <div style="width: 60%" v-on:click="selectFile(file.id)">
                  <i
                    class="md-icon material-icons"
                    style="font-size: 20px !important; padding-top: 2px"
                    >attach_file</i
                  >
                  {{ file.name }}
                </div>
                <div style="width: 35%" v-on:click="selectFile(file.id)">
                  {{ formatDate(file.modifiedTime) }}
                </div>
                <div style="width: 5%; color: #b3b3b3; cursor: pointer">
                  <i
                    title="Delete"
                    class="md-icon material-icons -delete"
                    v-on:click="deleteFile(file)"
                    >delete_sweep</i
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="table-pricing-list-import" v-else style="font-size: 11px">
          <div class="title-table">PRICE HISTORY</div>
          <div id="divHeadList">
            <div style="width: 7.3%" class="-text-right">Cost</div>
            <div style="width: 9.2%" class="-text-right">A3</div>
            <div style="width: 9.2%" class="-text-right">A2</div>
            <div style="width: 9.2%" class="-text-right">A1</div>
            <div style="width: 9.2%" class="-text-right">C3</div>
            <div style="width: 9.2%" class="-text-right">C2</div>
            <div style="width: 9.2%" class="-text-right">C1</div>
            <div style="width: 9.2%" class="-text-right">C0</div>
            <!--                    <div style="width: 9.2%;" class="-text-right">B1</div>
                    <div style="width: 9.2%;" class="-text-right">B2</div>-->
            <div style="width: 9.2%" class="-text-right">SR</div>
            <div style="width: 9.2%" class="-text-right">SS</div>
            <div style="width: 9.9%" class="-text-center">Effective Date</div>
            <!-- <div style="width: 9%;" class="-text-center">Exprie Date</div>
                    <div style="width: 9%;" class="-text-center">Last Modified</div> -->
          </div>
          <div id="divBodyList">
            <div
              :class="'row-bg-gray'"
              v-for="(item, impIndex) in tbPricingListLog"
              :key="impIndex"
            >
              <!-- <div style="width: 7.3%;" class="-text-right">
                            {{showPoint(item.cost , 'front')}}
                            <span style="font-size:11px">{{showPoint(item.cost, 'behind')}}</span>
                        </div> -->
              <div style="width: 7.3%" class="-text-right">
                <div v-if="item.cost_conv && item.cost_conv != ''">
                  {{ showPoint(item.cost_conv, "front") }}
                  <span style="font-size: 11px">{{
                    showPoint(item.cost_conv, "behind")
                  }}</span>
                </div>
                <div v-if="slcSearch == 1" class="-percent">
                  {{ formatNumber(item.cost, 2) }}
                </div>
              </div>

              <!-- <div style="width: 9.2%;" class="-text-right">
                            <div v-if="(item.price && item.price.price_a3 != '')" style="display: contents;">
                                {{showPoint(item.price.price_a3, 'front')}}
                                <span style="font-size:11px">{{showPoint(item.price.price_a3, 'behind')}}</span>
                            </div>
                        </div> -->
              <div style="width: 9.2%" class="-text-right">
                <div
                  v-if="
                    item.selling_conv_price &&
                    item.selling_conv_price.selling_conv_price_a3 != ''
                  "
                >
                  {{
                    showPoint(
                      item.selling_conv_price.selling_conv_price_a3,
                      "front"
                    )
                  }}
                  <span style="font-size: 11px">{{
                    showPoint(
                      item.selling_conv_price.selling_conv_price_a3,
                      "behind"
                    )
                  }}</span>
                </div>
                <div v-else style="visibility: hidden">-</div>
                <div
                  v-if="slcSearch == 1"
                  :class="item.price.price_a3 < 0 ? '-bgred' : '-percent'"
                >
                  {{ formatNumber(item.price.price_a3, 2) }}
                </div>
              </div>

              <!-- <div style="width: 9.2%;" class="-text-right">
                            <div v-if="(item.price && item.price.price_a2 != '')" style="display: contents;">
                                {{showPoint(item.price.price_a2, 'front')}}
                                <span style="font-size:11px">{{showPoint(item.price.price_a2, 'behind')}}</span>
                            </div>
                            <div v-else style="visibility: hidden;">-</div>
                            <div :class="(item.percent.percent_a2 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.percent.percent_a2 , 2)}}%</div>
                        </div> -->
              <div style="width: 9.2%" class="-text-right">
                <div
                  v-if="
                    item.selling_conv_price &&
                    item.selling_conv_price.selling_conv_price_a2 != ''
                  "
                  style="display: contents"
                >
                  {{
                    showPoint(
                      item.selling_conv_price.selling_conv_price_a2,
                      "front"
                    )
                  }}
                  <span style="font-size: 11px">{{
                    showPoint(
                      item.selling_conv_price.selling_conv_price_a2,
                      "behind"
                    )
                  }}</span>
                </div>
                <div v-else style="visibility: hidden">-</div>
                <div
                  v-if="slcSearch == 0"
                  :class="item.percent.percent_a2 < 0 ? '-bgred' : '-percent'"
                >
                  {{ formatNumber(item.percent.percent_a2, 2) }}%
                </div>
                <div
                  v-else-if="slcSearch == 1"
                  :class="item.price.price_a2 < 0 ? '-bgred' : '-percent'"
                >
                  {{ formatNumber(item.price.price_a2, 2) }}
                </div>
              </div>

              <!-- <div style="width: 9.2%;" class="-text-right">
                            <div v-if="(item.price && item.price.price_a1 != '')" style="display: contents;">
                                {{showPoint(item.price.price_a1, 'front')}}
                                <span style="font-size:11px">{{showPoint(item.price.price_a1, 'behind')}}</span>
                            </div>
                            <div v-else style="visibility: hidden;">-</div>
                            <div :class="(item.percent.percent_a1 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.percent.percent_a1 , 2)}}%</div>
                        </div> -->
              <div style="width: 9.2%" class="-text-right">
                <div
                  v-if="
                    item.selling_conv_price &&
                    item.selling_conv_price.selling_conv_price_a1 != ''
                  "
                  style="display: contents"
                >
                  {{
                    showPoint(
                      item.selling_conv_price.selling_conv_price_a1,
                      "front"
                    )
                  }}
                  <span style="font-size: 11px">{{
                    showPoint(
                      item.selling_conv_price.selling_conv_price_a1,
                      "behind"
                    )
                  }}</span>
                </div>
                <div v-else style="visibility: hidden">-</div>
                <div
                  v-if="slcSearch == 0"
                  :class="item.percent.percent_a1 < 0 ? '-bgred' : '-percent'"
                >
                  {{ formatNumber(item.percent.percent_a1, 2) }}%
                </div>
                <div
                  v-else-if="slcSearch == 1"
                  :class="item.price.price_a1 < 0 ? '-bgred' : '-percent'"
                >
                  {{ formatNumber(item.price.price_a1, 2) }}
                </div>
              </div>

              <!-- <div style="width: 9.2%;" class="-text-right">
                            <div v-if="(item.price && item.price.price_c3 != '')" style="display: contents;">
                                {{showPoint(item.price.price_c3, 'front')}}
                                <span style="font-size:11px">{{showPoint(item.price.price_c3, 'behind')}}</span>
                            </div>
                            <div v-else style="visibility: hidden;">-</div>
                            <div :class="(item.percent.percent_c3 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.percent.percent_c3 , 2)}}%</div>
                        </div> -->
              <div style="width: 9.2%" class="-text-right">
                <div
                  v-if="
                    item.selling_conv_price &&
                    item.selling_conv_price.selling_conv_price_c3 != ''
                  "
                  style="display: contents"
                >
                  {{
                    showPoint(
                      item.selling_conv_price.selling_conv_price_c3,
                      "front"
                    )
                  }}
                  <span style="font-size: 11px">{{
                    showPoint(
                      item.selling_conv_price.selling_conv_price_c3,
                      "behind"
                    )
                  }}</span>
                </div>
                <div v-else style="visibility: hidden">-</div>
                <div
                  v-if="slcSearch == 0"
                  :class="item.percent.percent_c3 < 0 ? '-bgred' : '-percent'"
                >
                  {{ formatNumber(item.percent.percent_c3, 2) }}%
                </div>
                <div
                  v-else-if="slcSearch == 1"
                  :class="item.price.price_c3 < 0 ? '-bgred' : '-percent'"
                >
                  {{ formatNumber(item.price.price_c3, 2) }}
                </div>
              </div>

              <!-- <div style="width: 9.2%;" class="-text-right">
                            <div v-if="(item.price && item.price.price_c2 != '')" style="display: contents;">
                                {{showPoint(item.price.price_c2, 'front')}}
                                <span style="font-size:11px">{{showPoint(item.price.price_c2, 'behind')}}</span>
                            </div>
                            <div v-else style="visibility: hidden;">-</div>
                            <div :class="(item.percent.percent_c2 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.percent.percent_c2 , 2)}}%</div>
                        </div> -->
              <div style="width: 9.2%" class="-text-right">
                <div
                  v-if="
                    item.selling_conv_price &&
                    item.selling_conv_price.selling_conv_price_c2 != ''
                  "
                  style="display: contents"
                >
                  {{
                    showPoint(
                      item.selling_conv_price.selling_conv_price_c2,
                      "front"
                    )
                  }}
                  <span style="font-size: 11px">{{
                    showPoint(
                      item.selling_conv_price.selling_conv_price_c2,
                      "behind"
                    )
                  }}</span>
                </div>
                <div v-else style="visibility: hidden">-</div>
                <div
                  v-if="slcSearch == 0"
                  :class="item.percent.percent_c2 < 0 ? '-bgred' : '-percent'"
                >
                  {{ formatNumber(item.percent.percent_c2, 2) }}%
                </div>
                <div
                  v-else-if="slcSearch == 1"
                  :class="item.price.price_c2 < 0 ? '-bgred' : '-percent'"
                >
                  {{ formatNumber(item.price.price_c2, 2) }}
                </div>
              </div>

              <!-- <div style="width: 9.2%;" class="-text-right">
                            <div v-if="(item.price && item.price.price_c1 != '')" style="display: contents;">
                                {{showPoint(item.price.price_c1, 'front')}}
                                <span style="font-size:11px">{{showPoint(item.price.price_c1, 'behind')}}</span>
                            </div>
                            <div v-else style="visibility: hidden;">-</div>
                            <div :class="(item.percent.percent_c1 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.percent.percent_c1 , 2)}}%</div>
                        </div> -->
              <div style="width: 9.2%" class="-text-right">
                <div
                  v-if="
                    item.selling_conv_price &&
                    item.selling_conv_price.selling_conv_price_c1 != ''
                  "
                  style="display: contents"
                >
                  {{
                    showPoint(
                      item.selling_conv_price.selling_conv_price_c1,
                      "front"
                    )
                  }}
                  <span style="font-size: 11px">{{
                    showPoint(
                      item.selling_conv_price.selling_conv_price_c1,
                      "behind"
                    )
                  }}</span>
                </div>
                <div v-else style="visibility: hidden">-</div>
                <div
                  v-if="slcSearch == 0"
                  :class="item.percent.percent_c1 < 0 ? '-bgred' : '-percent'"
                >
                  {{ formatNumber(item.percent.percent_c1, 2) }}%
                </div>
                <div
                  v-else-if="slcSearch == 1"
                  :class="item.price.price_c1 < 0 ? '-bgred' : '-percent'"
                >
                  {{ formatNumber(item.price.price_c1, 2) }}
                </div>
              </div>

              <!-- <div style="width: 9.2%;" class="-text-right">
                            <div v-if="(item.price && item.price.price_c0 != '')" style="display: contents;">
                                {{showPoint(item.price.price_c0, 'front')}}
                                <span style="font-size:11px">{{showPoint(item.price.price_c0, 'behind')}}</span>
                            </div>
                            <div v-else style="visibility: hidden;">-</div>
                            <div :class="(item.percent.percent_c0 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.percent.percent_c0 , 2)}}%</div>
                        </div> -->
              <div style="width: 9.2%" class="-text-right">
                <div
                  v-if="
                    item.selling_conv_price &&
                    item.selling_conv_price.selling_conv_price_c0 != ''
                  "
                  style="display: contents"
                >
                  {{
                    showPoint(
                      item.selling_conv_price.selling_conv_price_c0,
                      "front"
                    )
                  }}
                  <span style="font-size: 11px">{{
                    showPoint(
                      item.selling_conv_price.selling_conv_price_c0,
                      "behind"
                    )
                  }}</span>
                </div>
                <div v-else style="visibility: hidden">-</div>
                <div
                  v-if="slcSearch == 0"
                  :class="item.percent.percent_c0 < 0 ? '-bgred' : '-percent'"
                >
                  {{ formatNumber(item.percent.percent_c0, 2) }}%
                </div>
                <div
                  v-else-if="slcSearch == 1"
                  :class="item.price.price_c0 < 0 ? '-bgred' : '-percent'"
                >
                  {{ formatNumber(item.price.price_c0, 2) }}
                </div>
              </div>

              <!-- <div style="width: 9.2%;" class="-text-right">
                            <div v-if="(item.price && item.price.price_b1 != '')" style="display: contents;">
                                {{showPoint(item.price.price_b1, 'front')}}
                                <span style="font-size:11px">{{showPoint(item.price.price_b1, 'behind')}}</span>
                            </div>
                            <div v-else style="visibility: hidden;">-</div>
                            <div :class="(item.percent.percent_b1 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.percent.percent_b1 , 2)}}%</div>
                        </div> -->
              <!--                        <div style="width: 9.2%;" class="-text-right">
                            <div v-if="(item.selling_conv_price && item.selling_conv_price.selling_conv_price_b1 != '')" style="display: contents;">
                                {{showPoint(item.selling_conv_price.selling_conv_price_b1, 'front')}}
                                <span style="font-size:11px">{{showPoint(item.selling_conv_price.selling_conv_price_b1, 'behind')}}</span>
                            </div>
                            <div v-else style="visibility: hidden;">-</div>
                            <div v-if="(slcSearch == 0)" :class="(item.percent.percent_b1 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.percent.percent_b1 , 2)}}%</div>
                            <div v-else-if="(slcSearch == 1)" :class="(item.price.price_b1 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.price.price_b1 , 2)}}</div>
                        </div>-->

              <!-- <div style="width: 9.2%;" class="-text-right">
                            <div v-if="(item.price && item.price.price_b2 != '')" style="display: contents;">
                                {{showPoint(item.price.price_b2, 'front')}}
                                <span style="font-size:11px">{{showPoint(item.price.price_b2, 'behind')}}</span>
                            </div>
                            <div v-else style="visibility: hidden;">-</div>
                            <div :class="(item.percent.percent_b2 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.percent.percent_b2 , 2)}}%</div>
                        </div> -->
              <!--                        <div style="width: 9.2%;" class="-text-right">
                            <div v-if="(item.selling_conv_price && item.selling_conv_price.selling_conv_price_b2 != '')" style="display: contents;">
                                {{showPoint(item.selling_conv_price.selling_conv_price_b2, 'front')}}
                                <span style="font-size:11px">{{showPoint(item.selling_conv_price.selling_conv_price_b2, 'behind')}}</span>
                            </div>
                            <div v-else style="visibility: hidden;">-</div>
                            <div v-if="(slcSearch == 0)" :class="(item.percent.percent_b2 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.percent.percent_b2 , 2)}}%</div>
                            <div v-else-if="(slcSearch == 1)" :class="(item.price.price_b2 < 0) ? '-bgred' : '-percent'">{{formatNumber(item.price.price_b2 , 2)}}</div>
                        </div>-->
              <div style="width: 9.2%" class="-text-right">
                <div
                  v-if="
                    item.selling_conv_price &&
                    item.selling_conv_price.selling_conv_price_sr != ''
                  "
                  style="display: contents"
                >
                  {{
                    showPoint(
                      item.selling_conv_price.selling_conv_price_sr,
                      "front"
                    )
                  }}
                  <span style="font-size: 11px">{{
                    showPoint(
                      item.selling_conv_price.selling_conv_price_sr,
                      "behind"
                    )
                  }}</span>
                </div>
                <div v-else style="visibility: hidden">-</div>
                <div
                  v-if="slcSearch == 0"
                  :class="item.percent.percent_sr < 0 ? '-bgred' : '-percent'"
                >
                  {{ formatNumber(item.percent.percent_sr, 2) }}%
                </div>
                <div
                  v-else-if="slcSearch == 1"
                  :class="item.price.price_sr < 0 ? '-bgred' : '-percent'"
                >
                  {{ formatNumber(item.price.price_sr, 2) }}
                </div>
              </div>
              <div style="width: 9.2%" class="-text-right">
                <div
                  v-if="
                    item.selling_conv_price &&
                    item.selling_conv_price.selling_conv_price_ss != ''
                  "
                  style="display: contents"
                >
                  {{
                    showPoint(
                      item.selling_conv_price.selling_conv_price_ss,
                      "front"
                    )
                  }}
                  <span style="font-size: 11px">{{
                    showPoint(
                      item.selling_conv_price.selling_conv_price_ss,
                      "behind"
                    )
                  }}</span>
                </div>
                <div v-else style="visibility: hidden">-</div>
                <div
                  v-if="slcSearch == 0"
                  :class="item.percent.percent_ss < 0 ? '-bgred' : '-percent'"
                >
                  {{ formatNumber(item.percent.percent_ss, 2) }}%
                </div>
                <div
                  v-else-if="slcSearch == 1"
                  :class="item.price.price_ss < 0 ? '-bgred' : '-percent'"
                >
                  {{ formatNumber(item.price.price_ss, 2) }}
                </div>
              </div>

              <div style="width: 9.9%" class="-text-center">
                {{ item.effective_date }}
              </div>
              <!-- <div style="width: 9%;" class="-text-center">{{item.expiry_date}}</div>
                        <div style="width: 9%;" class="-text-center">{{item.mtime}}</div> -->
            </div>
          </div>
        </div>
      </div>
      <md-dialog-actions class="-action" v-if="modeDialog == 'browseFile'">
        <md-button class="md-primary -cancel" @click="cancelPopup">
          <b>CANCEL</b>
        </md-button>
        <md-button
          :class="
            importConfirmDisable == 1 ? 'md-primary' : 'md-primary -confirm'
          "
          @click="confirmPopup"
          :disabled="importConfirmDisable == 1"
        >
          <b>CONFIRM</b>
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog
      :md-active.sync="showMsgImport"
      class="pricinglist dialog-import -message"
      :md-click-outside-to-close="clickOutside"
    >
      <md-dialog-title style="color: red; margin-bottom: 10px"
        >Message Dialog</md-dialog-title
      >
      <ul
        v-for="(error, errorIndex) in listError"
        :key="errorIndex"
        style="padding-left: 60px; margin-top: 10px; margin-bottom: 10px"
      >
        <li>{{ error }}</li>
      </ul>
      <!-- <div class="md-layout dialog-content">
            <div id="table-pricing-list-import-alert">
                <div id="divHeadListAlert">
                    <div style="width: 15%;" class="-text-center -row-pd-right">Row</div>
                    <div style="width: 20%;">Product code</div>
                    <div style="width: 65%;" class="-text-center">message</div>
                </div>
                <div id="divBodyListAlert">
                    <div :class="'row-bg-gray'" v-for="(itemMsg, msgIndex) in tbMessageImport" :key="msgIndex">
                        <div style="width: 15%;" class="-text-center -row-pd-right">{{ itemMsg.row }}</div>
                        <div style="width: 20%;">{{ itemMsg.code }}</div>
                        <div style="width: 65%;">{{ itemMsg.msg }}</div>
                    </div>
                </div>
            </div>
        </div> -->
      <md-dialog-actions class="-action -error">
        <md-button
          class="md-primary -cancel"
          @click="showMsgImport = false"
          style="font-weight: bold"
          >OK</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <md-dialog-confirm
      md-title="Cancel import"
      :md-active.sync="dialogConfirmCancel"
      md-content="Are you sure you want to cancel ?"
      md-cancel-text="No"
      md-confirm-text="Yes"
      @md-confirm="importCancel()"
      @md-cancel="onClose()"
    ></md-dialog-confirm>
    <md-dialog-confirm
      md-title="Confirm import"
      :md-active.sync="dialogConfirmSave"
      md-content="Are you sure you want to save ?"
      md-cancel-text="No"
      md-confirm-text="Yes"
      @md-confirm="importConfirm()"
      @md-cancel="onClose()"
    ></md-dialog-confirm>
    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ dContent }}</span>
      <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
    <md-dialog-confirm
      md-title="Delete File"
      :md-active.sync="dialogConfirmDelete"
      :md-content="delFileName"
      md-cancel-text="No"
      md-confirm-text="Yes"
      @md-confirm="fileDelete()"
      @md-cancel="onClose()"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import moment from "moment-timezone";
import PricingService from "@/services/pricing";
import XLSX from "xlsx";

export default {
  name: "pricinglistall",
  // "tbPricingListLog",
  props: [
    "valueTab",
    "tbPricingList",
    "loadData",
    "total_all_int",
    "changeTab",
    "dataFilter",
    "filterChips",
    "selectedMenu",
    "selectedMenuOld",
  ],
  data() {
    return {
      //   valueTab: "ALL",
      // valueTab: "UPCOMING",
      //   valueTab: "WARNING",
      slcSearch: 0,
      status: ["% Increase on selling unit", "Stocking unit"],
      optWarning: 0,
      warningType: [
        "All",
        "Price type have value equal 0",
        "All price type have the same value",
        "A3 value is lower than Cx values",
        "C3 value is lower than C2 values",
        "C2 value is lower than C1 values",
        "C1 value is lower than C0 values",
        "value price have equal",
      ],
      delFileName: "",
      listError: [],
      fileID: "",
      fileIdDelete: "",
      fileNameDelete: "",
      listImport: [],
      tbPricingListLog: [],
      selectedRow: "",
      checkLoad: [],
      searchList: "",
      accept: ".csv,.xlsx",
      showDialog: false,
      modeDialog: "view",
      eff_date: "",
      // eff_date: moment().startOf("month").format("YYYY-MM-DD"),
      tbPricingListImport: [],
      price_updates: "0",
      tbMessageImport: [],
      showMsgImport: false,
      importConfirmDisable: true,
      disabledDates: (date) => {
        let today = new Date();
        return date < today;
      },
      dialogConfirmCancel: false,
      dialogConfirmSave: false,
      dialogConfirmDelete: false,
      json_data: [],
      dContent: "",
      showSnackbar: false,
      position: "center",
      duration: 4000,
      // isInfinity: false,
      isInfinity: true,
      iprodOld: "",
      loadExport: false,
      valueTabOld: "",
      vChipsFilter: [],
      showExportBtn: false,
      showTemplateUpdate: false,
      _showImportBtn: false,
      get showImportBtn() {
        return this._showImportBtn;
      },
      set showImportBtn(value) {
        this._showImportBtn = value;
      },
      loading: false,
      loadingPopup: false,
      checkBackdrop: false,
      clickOutside: false,
      placeholderSearch: "Search Product Code...",
      titleSearch: "Click to change search by item code",
      checkSearch: 0,
      menuOld: this.selectedMenuOld,
    };
  },
  watch: {
    changeTab() {
      // console.log("this.selectedMenu ==>", this.selectedMenu);
      // console.log("this.selectedMenuOld ==>", this.menuOld);
      if (
        this.selectedMenu == "bookprice" ||
        (this.selectedMenu == "price" && this.menuOld == "bookprice")
      ) {
        this.searchList = "";
        this.menuOld = "price";
      }
      //   this.checkedProductsAll = false;
      //   this.checkedProducts = [];
    },
    filterChips() {
      this.vChipsFilter = this.filterChips;
    },
    // eff_date() {
    //     let effDate = moment(this.eff_date).format("YYYY-MM-DD");
    //     console.log("effDate ==>", effDate);
    //     if(effDate != "" || effDate != null) {
    //         this.importConfirmDisable = false;
    //     }
    // }
  },
  mounted() {
    this.initPermission();
  },
  methods: {
    setWidthHead(valueTab) {
      if (valueTab === "WARNING") {
        return "width: 99.7%";
      } else if (valueTab === "UPCOMING") {
        return "width: 99.7%";
      } else {
        return "width: 99.4%";
      }
    },
    selectWarning(select) {
      this.onChangeSearch("input");
    },
    selectSearch() {
      this.checkSearch++;
      if (this.checkSearch == 1) {
        this.placeholderSearch = "Search Product Name...";
        this.titleSearch = "Click to change search by item code";
        // } else if(this.checkSearch == 2) {
        // this.placeholderSearch = "Search Product Code or Name...";
      } else {
        this.placeholderSearch = "Search Product Code...";
        this.titleSearch = "Click to change search by item name";
        this.checkSearch = 0;
      }

      if (this.searchList != "") {
        this.onChangeSearch("input");
      }
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    initPermission() {
      let path = this.$route.path;
      let arr_path = path.split("/");
      let acl = this.$jwt.decode(localStorage.getItem("token")).acl;
      let permission = acl[arr_path[1]].menus[arr_path[2]];
      if (permission.add === "true" || permission.add === true) {
        this.showImportBtn = true;
      }
      if (permission.export === "true" || permission.export === true) {
        this.showExportBtn = true;
      }
      if (permission.edit === "true" || permission.edit === true) {
        this.showTemplateUpdate = true;
      }
    },
    openDlg(value) {
      // this.modeDialog = "browseFile";
      this.modeDialog = "view";
      this.selectedRow = value;
      this.eff_date = "";
      this.showDialog = true;
      //   this.loadData = true;
      let vDataPercent = [];
      if (this.valueTab === "UPCOMING") {
        /* push current effective data */
        vDataPercent.push({
          price: {
            price_a3:
              value.price && value.price.price_A3 != ""
                ? this.formatNumber(value.price.price_A3, 3)
                : "",
            price_a2:
              value.price && value.price.price_A2 != ""
                ? this.formatNumber(value.price.price_A2, 3)
                : "",
            price_a1:
              value.price && value.price.price_A1 != ""
                ? this.formatNumber(value.price.price_A1, 3)
                : "",
            price_c3:
              value.price && value.price.price_C3 != ""
                ? this.formatNumber(value.price.price_C3, 3)
                : "",
            price_c2:
              value.price && value.price.price_C2 != ""
                ? this.formatNumber(value.price.price_C2, 3)
                : "",
            price_c1:
              value.price && value.price.price_C1 != ""
                ? this.formatNumber(value.price.price_C1, 3)
                : "",
            price_c0:
              value.price && value.price.price_C0 != ""
                ? this.formatNumber(value.price.price_C0, 3)
                : "",
            price_sr:
              value.price && value.price.price_SR != ""
                ? this.formatNumber(value.price.price_SR, 3)
                : "",
            price_ss:
              value.price && value.price.price_SS != ""
                ? this.formatNumber(value.price.price_SS, 3)
                : "",
            price_b1:
              value.price && value.price.price_b1 != ""
                ? this.formatNumber(value.price.price_b1, 3)
                : "",
            price_b2:
              value.price && value.price.price_b2 != ""
                ? this.formatNumber(value.price.price_b2, 3)
                : "",
          },
          selling_conv_price: {
            selling_conv_price_a3:
              value.selling_conv_price &&
              value.selling_conv_price.selling_conv_price_a3 != ""
                ? this.formatNumber(
                    value.selling_conv_price.selling_conv_price_a3,
                    2
                  )
                : "",
            selling_conv_price_a2:
              value.selling_conv_price &&
              value.selling_conv_price.selling_conv_price_a2 != ""
                ? this.formatNumber(
                    value.selling_conv_price.selling_conv_price_a2,
                    2
                  )
                : "",
            selling_conv_price_a1:
              value.selling_conv_price &&
              value.selling_conv_price.selling_conv_price_a1 != ""
                ? this.formatNumber(
                    value.selling_conv_price.selling_conv_price_a1,
                    2
                  )
                : "",
            selling_conv_price_c3:
              value.selling_conv_price &&
              value.selling_conv_price.selling_conv_price_c3 != ""
                ? this.formatNumber(
                    value.selling_conv_price.selling_conv_price_c3,
                    2
                  )
                : "",
            selling_conv_price_c2:
              value.selling_conv_price &&
              value.selling_conv_price.selling_conv_price_c2 != ""
                ? this.formatNumber(
                    value.selling_conv_price.selling_conv_price_c2,
                    2
                  )
                : "",
            selling_conv_price_c1:
              value.selling_conv_price &&
              value.selling_conv_price.selling_conv_price_c1 != ""
                ? this.formatNumber(
                    value.selling_conv_price.selling_conv_price_c1,
                    2
                  )
                : "",
            selling_conv_price_c0:
              value.selling_conv_price &&
              value.selling_conv_price.selling_conv_price_c0 != ""
                ? this.formatNumber(
                    value.selling_conv_price.selling_conv_price_c0,
                    2
                  )
                : "",
            selling_conv_price_sr:
              value.selling_conv_price &&
              value.selling_conv_price.selling_conv_price_sr != ""
                ? this.formatNumber(
                    value.selling_conv_price.selling_conv_price_sr,
                    2
                  )
                : "",
            selling_conv_price_ss:
              value.selling_conv_price &&
              value.selling_conv_price.selling_conv_price_ss != ""
                ? this.formatNumber(
                    value.selling_conv_price.selling_conv_price_ss,
                    2
                  )
                : "",
            selling_conv_price_b1:
              value.selling_conv_price &&
              value.selling_conv_price.selling_conv_price_b1 != ""
                ? this.formatNumber(
                    value.selling_conv_price.selling_conv_price_b1,
                    2
                  )
                : "",
            selling_conv_price_b2:
              value.selling_conv_price &&
              value.selling_conv_price.selling_conv_price_b2 != ""
                ? this.formatNumber(
                    value.selling_conv_price.selling_conv_price_b2,
                    2
                  )
                : "",
          },
          percent: {
            percent_a3: value.percent_a3 ? value.percent_a3 : "0",
            percent_a2: value.percent_a2 ? value.percent_a2 : "0",
            percent_a1: value.percent_a1 ? value.percent_a1 : "0",
            percent_c3: value.percent_c3 ? value.percent_c3 : "0",
            percent_c2: value.percent_c2 ? value.percent_c2 : "0",
            percent_c1: value.percent_c1 ? value.percent_c1 : "0",
            percent_c0: value.percent_c0 ? value.percent_c0 : "0",
            percent_sr: value.percent_sr ? value.percent_sr : "0",
            percent_ss: value.percent_ss ? value.percent_ss : "0",
            percent_b1: value.percent_b1 ? value.percent_b1 : "0",
            percent_b2: value.percent_b2 ? value.percent_b2 : "0",
          },
          mtime: value.mtime,
          effective_date: value.effective_date,
          expiry_date: value.expiry_date,
          cost: value.cost,
          cost_conv: value.cost_conv,
        });
      } else if (this.valueTab !== "UPCOMING") {
        PricingService.getPricingLog(value.iprod)
          .then((response) => {
            // console.log(response);
            for (let i = 0; i < response.length; i++) {
              let res = response[i];

              let percent_c3 = 0;
              let percent_c2 = 0;
              let percent_c1 = 0;
              let percent_c0 = 0;
              let percent_b2 = 0;
              let percent_b1 = 0;
              let percent_a1 = 0;
              let percent_a2 = 0;
              let percent_a3 = 0;
              let percent_sr = 0;
              let percent_ss = 0;

              if (res.price != undefined) {
                let temp = "";
                res.price.A2 =
                  typeof res.price.A2 == "undefined" ? temp : res.price.A2;
                res.price.A1 =
                  typeof res.price.A1 == "undefined" ? temp : res.price.A1;
                res.price.C3 =
                  typeof res.price.C3 == "undefined" ? temp : res.price.C3;
                res.price.C2 =
                  typeof res.price.C2 == "undefined" ? temp : res.price.C2;
                res.price.C1 =
                  typeof res.price.C1 == "undefined" ? temp : res.price.C1;
                res.price.C0 =
                  typeof res.price.C0 == "undefined" ? temp : res.price.C0;
                res.price.SR =
                  typeof res.price.SR == "undefined" ? temp : res.price.SR;
                res.price.SS =
                  typeof res.price.SS == "undefined" ? temp : res.price.SS;
                res.price["B2-MT"] =
                  typeof res.price["B2-MT"] == "undefined"
                    ? temp
                    : res.price["B2-MT"];
                res.price["B1-MT"] =
                  typeof res.price["B1-MT"] == "undefined"
                    ? temp
                    : res.price["B1-MT"];
              }

              if (res.selling_conv_price != undefined) {
                let temp_conv = "";
                res.selling_conv_price.A2 =
                  typeof res.selling_conv_price.A2 == "undefined"
                    ? temp_conv
                    : res.selling_conv_price.A2;
                res.selling_conv_price.A1 =
                  typeof res.selling_conv_price.A1 == "undefined"
                    ? temp_conv
                    : res.selling_conv_price.A1;
                res.selling_conv_price.C3 =
                  typeof res.selling_conv_price.C3 == "undefined"
                    ? temp_conv
                    : res.selling_conv_price.C3;
                res.selling_conv_price.C2 =
                  typeof res.selling_conv_price.C2 == "undefined"
                    ? temp_conv
                    : res.selling_conv_price.C2;
                res.selling_conv_price.C1 =
                  typeof res.selling_conv_price.C1 == "undefined"
                    ? temp_conv
                    : res.selling_conv_price.C1;
                res.selling_conv_price.C0 =
                  typeof res.selling_conv_price.C0 == "undefined"
                    ? temp_conv
                    : res.selling_conv_price.C0;
                res.selling_conv_price["B2-MT"] =
                  typeof res.selling_conv_price["B2-MT"] == "undefined"
                    ? temp_conv
                    : res.selling_conv_price["B2-MT"];
                res.selling_conv_price["B1-MT"] =
                  typeof res.selling_conv_price["B1-MT"] == "undefined"
                    ? temp_conv
                    : res.selling_conv_price["B1-MT"];
                res.selling_conv_price.SR =
                  typeof res.selling_conv_price.SR == "undefined"
                    ? temp_conv
                    : res.selling_conv_price.SR;
                res.selling_conv_price.SS =
                  typeof res.selling_conv_price.SS == "undefined"
                    ? temp_conv
                    : res.selling_conv_price.SS;
              }

              //-------------------
              let v_a3 =
                parseFloat(res.selling_conv_price.A3) === 0
                  ? 0
                  : parseFloat(res.selling_conv_price.A3);
              let percent_selling_conv_price_a3 =
                res.selling_conv_price.A3 === ""
                  ? ""
                  : res.selling_conv_price.A3;
              let percent_selling_conv_price_C3 =
                res.selling_conv_price.C3 === ""
                  ? ""
                  : res.selling_conv_price.C3;
              let percent_selling_conv_price_C2 =
                res.selling_conv_price.C2 === ""
                  ? ""
                  : res.selling_conv_price.C2;
              let percent_selling_conv_price_C1 =
                res.selling_conv_price.C1 === ""
                  ? ""
                  : res.selling_conv_price.C1;
              let percent_selling_conv_price_C0 =
                res.selling_conv_price.C0 === ""
                  ? ""
                  : res.selling_conv_price.C0;
              let percent_selling_conv_price_B1MT =
                res.selling_conv_price["B1-MT"] === ""
                  ? ""
                  : res.selling_conv_price["B1-MT"];
              let percent_selling_conv_price_B2MT =
                res.selling_conv_price["B2-MT"] === ""
                  ? ""
                  : res.selling_conv_price["B2-MT"];
              let percent_selling_conv_price_SR =
                res.selling_conv_price.SR === ""
                  ? ""
                  : res.selling_conv_price.SR;
              let percent_selling_conv_price_SS =
                res.selling_conv_price.SS === ""
                  ? ""
                  : res.selling_conv_price.SS;
              let percent_selling_conv_price_A2 =
                res.selling_conv_price.A2 === ""
                  ? ""
                  : res.selling_conv_price.A2;
              let percent_selling_conv_price_A1 =
                res.selling_conv_price.A1 === ""
                  ? ""
                  : res.selling_conv_price.A1;
              if (v_a3 === 0) {
                percent_a3 = 0;
                percent_c3 = 0;
                percent_c2 = 0;
                percent_c1 = 0;
                percent_c0 = 0;
                percent_b1 = 0;
                percent_b2 = 0;
                percent_sr = 0;
                percent_ss = 0;
              } else {
                percent_a3 =
                  percent_selling_conv_price_a3 === ""
                    ? 0
                    : ((parseFloat(percent_selling_conv_price_a3) -
                        parseFloat(percent_selling_conv_price_a3)) /
                        parseFloat(percent_selling_conv_price_a3)) *
                      100;
                percent_c3 =
                  percent_selling_conv_price_C3 === ""
                    ? 0
                    : ((parseFloat(percent_selling_conv_price_C3) -
                        parseFloat(percent_selling_conv_price_a3)) /
                        parseFloat(percent_selling_conv_price_a3)) *
                      100;
                percent_c2 =
                  percent_selling_conv_price_C2 === ""
                    ? 0
                    : ((parseFloat(percent_selling_conv_price_C2) -
                        parseFloat(percent_selling_conv_price_a3)) /
                        parseFloat(percent_selling_conv_price_a3)) *
                      100;
                percent_c1 =
                  percent_selling_conv_price_C1 === ""
                    ? 0
                    : ((parseFloat(percent_selling_conv_price_C1) -
                        parseFloat(percent_selling_conv_price_a3)) /
                        parseFloat(percent_selling_conv_price_a3)) *
                      100;
                percent_c0 =
                  percent_selling_conv_price_C0 === ""
                    ? 0
                    : ((parseFloat(percent_selling_conv_price_C0) -
                        parseFloat(percent_selling_conv_price_a3)) /
                        parseFloat(percent_selling_conv_price_a3)) *
                      100;
                percent_b1 =
                  percent_selling_conv_price_B1MT === ""
                    ? 0
                    : ((parseFloat(percent_selling_conv_price_B1MT) -
                        parseFloat(percent_selling_conv_price_a3)) /
                        parseFloat(percent_selling_conv_price_a3)) *
                      100;
                percent_b2 =
                  percent_selling_conv_price_B2MT === ""
                    ? 0
                    : ((parseFloat(percent_selling_conv_price_B2MT) -
                        parseFloat(percent_selling_conv_price_a3)) /
                        parseFloat(percent_selling_conv_price_a3)) *
                      100;
                percent_sr =
                  percent_selling_conv_price_SR === ""
                    ? 0
                    : ((parseFloat(percent_selling_conv_price_SR) -
                        parseFloat(percent_selling_conv_price_a3)) /
                        parseFloat(percent_selling_conv_price_a3)) *
                      100;
                percent_ss =
                  percent_selling_conv_price_SS === ""
                    ? 0
                    : ((parseFloat(percent_selling_conv_price_SS) -
                        parseFloat(percent_selling_conv_price_a3)) /
                        parseFloat(percent_selling_conv_price_a3)) *
                      100;
              }

              let v_a2 =
                parseFloat(percent_selling_conv_price_A2) === 0
                  ? 0
                  : parseFloat(percent_selling_conv_price_A2);
              if (v_a2 === 0) {
                percent_a2 = 0;
              } else {
                percent_a2 =
                  percent_selling_conv_price_A2 === ""
                    ? 0
                    : ((parseFloat(percent_selling_conv_price_A2) -
                        parseFloat(percent_selling_conv_price_a3)) /
                        parseFloat(percent_selling_conv_price_A2)) *
                      100;
              }

              let v_a1 =
                parseFloat(percent_selling_conv_price_A1) === 0
                  ? 0
                  : parseFloat(percent_selling_conv_price_A1);
              if (v_a1 === 0) {
                percent_a1 = 0;
              } else {
                percent_a1 =
                  percent_selling_conv_price_A1 === ""
                    ? 0
                    : ((parseFloat(percent_selling_conv_price_A1) -
                        parseFloat(percent_selling_conv_price_a3)) /
                        parseFloat(percent_selling_conv_price_A1)) *
                      100;
              }

              // let temp = 889098.399;
              // res.cost = temp
              //   // var temp = 508.3999999998;
              //   res.price = {
              //     A2: temp,
              //     A1: temp,
              //     C3: temp,
              //     C2: temp,
              //     C0: temp,
              //     B2: temp,
              //     B1: temp,
              //     A3: temp
              //   };

              // console.log(res.price);

              // if (res.price.A3) {
              // make array()
              // res.price.A3 =
              //   typeof res.price.A3 == "undefined" ? "" : res.price.A3;
              // res.price.A2 =
              //   typeof res.price.A2 == "undefined" ? "" : res.price.A2;
              // res.price.A1 =
              //   typeof res.price.A1 == "undefined" ? "" : res.price.A1;
              // res.price.C3 =
              //   typeof res.price.C3 == "undefined" ? "" : res.price.C3;
              // res.price.C2 =
              //   typeof res.price.C2 == "undefined" ? "" : res.price.C2;
              // res.price.C1 =
              //   typeof res.price.C1 == "undefined" ? "" : res.price.C1;
              // res.price.C0 =
              //   typeof res.price.C0 == "undefined" ? "" : res.price.C0;
              // res.price.SR =
              //   typeof res.price.SR == "undefined" ? "" : res.price.SR;
              // res.price.SS =
              //   typeof res.price.SS == "undefined" ? "" : res.price.SS;
              // res.price["B2-MT"] =
              //   typeof res.price["B2-MT"] == "undefined"
              //     ? ""
              //     : res.price["B2-MT"];
              // res.price["B1-MT"] =
              //   typeof res.price["B1-MT"] == "undefined"
              //     ? ""
              //     : res.price["B1-MT"];
              //-------------------
              // percent_a1 =
              //   ((parseFloat(res.price.A1) - parseFloat(res.price.A3)) /
              //     parseFloat(res.price.A1)) *
              //   100;
              // percent_a2 =
              //   ((parseFloat(res.price.A2) - parseFloat(res.price.A3)) /
              //     parseFloat(res.price.A2)) *
              //   100;
              // percent_a3 =
              //   ((parseFloat(res.price.A3) - parseFloat(res.price.A3)) /
              //     parseFloat(res.price.A3)) *
              //   100;
              // percent_c3 =
              //   ((parseFloat(res.price.C3) - parseFloat(res.price.A3)) /
              //     parseFloat(res.price.A3)) *
              //   100;
              // percent_c2 =
              //   ((parseFloat(res.price.C2) - parseFloat(res.price.A3)) /
              //     parseFloat(res.price.A3)) *
              //   100;
              // percent_c1 =
              //   ((parseFloat(res.price.C1) - parseFloat(res.price.A3)) /
              //     parseFloat(res.price.A3)) *
              //   100;
              // percent_c0 =
              //   ((parseFloat(res.price.C0) - parseFloat(res.price.A3)) /
              //     parseFloat(res.price.A3)) *
              //   100;
              // percent_sr =
              //   ((parseFloat(res.price.SR) - parseFloat(res.price.A3)) /
              //     parseFloat(res.price.A3)) *
              //   100;
              // percent_ss =
              //   ((parseFloat(res.price.SS) - parseFloat(res.price.A3)) /
              //     parseFloat(res.price.A3)) *
              //   100;
              // percent_b1 =
              //   ((parseFloat(res.price["B1-MT"]) - parseFloat(res.price.A3)) /
              //     parseFloat(res.price.A3)) *
              //   100;
              // percent_b2 =
              //   ((parseFloat(res.price["B2-MT"]) - parseFloat(res.price.A3)) /
              //     parseFloat(res.price.A3)) *
              //   100;
              // }
              let effective_date = "";
              let mtime = "";
              let expiry_date = "";
              if (
                res.effective_date != "" &&
                res.effective_date != null &&
                res.effective_date != " "
              ) {
                let res_effective_date = new Date(res.effective_date);
                let year_eff = res_effective_date.getFullYear();
                let month_eff =
                  (res_effective_date.getMonth() < 9 ? "0" : "") +
                  (res_effective_date.getMonth() + 1);
                let date_eff =
                  (res_effective_date.getDate() < 10 ? "0" : "") +
                  res_effective_date.getDate();
                effective_date = date_eff + "-" + month_eff + "-" + year_eff;
              }
              if (
                res.expiry_date != "" &&
                res.expiry_date != null &&
                res.expiry_date != " " &&
                typeof res.expiry_date != "undefined" &&
                res.expiry_date != "0000-00-00 00:00:00"
              ) {
                let res_expiry_date = new Date(res.expiry_date);
                let year_eff = res_expiry_date.getFullYear();
                let month_eff =
                  (res_expiry_date.getMonth() < 9 ? "0" : "") +
                  (res_expiry_date.getMonth() + 1);
                let date_eff =
                  (res_expiry_date.getDate() < 10 ? "0" : "") +
                  res_expiry_date.getDate();
                expiry_date = date_eff + "-" + month_eff + "-" + year_eff;
              }

              if (res.mtime != "" && res.mtime != null && res.mtime != " ") {
                let res_mtime = new Date(res.mtime);
                let year_mtime = res_mtime.getFullYear();
                let month_mtime =
                  (res_mtime.getMonth() < 9 ? "0" : "") +
                  (res_mtime.getMonth() + 1);
                let date_mtime =
                  (res_mtime.getDate() < 10 ? "0" : "") + res_mtime.getDate();
                mtime = date_mtime + "-" + month_mtime + "-" + year_mtime;
              }
              let cost = typeof res.cost != "undefined" ? res.cost : "";
              let cost_conv =
                typeof res.cost_conv != "undefined" ? res.cost_conv : "";
              vDataPercent.push({
                price: {
                  price_a3:
                    res.price && res.price.A3 != undefined
                      ? this.formatNumber(res.price.A3, 3)
                      : "",
                  price_a2:
                    res.price && res.price.A2 != undefined
                      ? this.formatNumber(res.price.A2, 3)
                      : "",
                  price_a1:
                    res.price && res.price.A1 != undefined
                      ? this.formatNumber(res.price.A1, 3)
                      : "",
                  price_c3:
                    res.price && res.price.C3 != undefined
                      ? this.formatNumber(res.price.C3, 3)
                      : "",
                  price_c2:
                    res.price && res.price.C2 != undefined
                      ? this.formatNumber(res.price.C2, 3)
                      : "",
                  price_c1:
                    res.price && res.price.C1 != undefined
                      ? this.formatNumber(res.price.C1, 3)
                      : "",
                  price_c0:
                    res.price && res.price.C0 != undefined
                      ? this.formatNumber(res.price.C0, 3)
                      : "",
                  price_sr:
                    res.price && res.price.SR != undefined
                      ? this.formatNumber(res.price.SR, 3)
                      : "",
                  price_ss:
                    res.price && res.price.SS != undefined
                      ? this.formatNumber(res.price.SS, 3)
                      : "",
                  price_b1:
                    res.price && res.price["B1-MT"] != undefined
                      ? this.formatNumber(res.price["B1-MT"], 3)
                      : "",
                  price_b2:
                    res.price && res.price["B2-MT"] != undefined
                      ? this.formatNumber(res.price["B2-MT"], 3)
                      : "",
                },
                selling_conv_price: {
                  selling_conv_price_a3:
                    res.selling_conv_price &&
                    res.selling_conv_price.A3 != undefined
                      ? this.formatNumber(res.selling_conv_price.A3, 2)
                      : 0,
                  selling_conv_price_a2:
                    res.selling_conv_price &&
                    res.selling_conv_price.A2 != undefined
                      ? this.formatNumber(res.selling_conv_price.A2, 2)
                      : 0,
                  selling_conv_price_a1:
                    res.selling_conv_price &&
                    res.selling_conv_price.A1 != undefined
                      ? this.formatNumber(res.selling_conv_price.A1, 2)
                      : 0,
                  selling_conv_price_c3:
                    res.selling_conv_price &&
                    res.selling_conv_price.C3 != undefined
                      ? this.formatNumber(res.selling_conv_price.C3, 2)
                      : 0,
                  selling_conv_price_c2:
                    res.selling_conv_price &&
                    res.selling_conv_price.C2 != undefined
                      ? this.formatNumber(res.selling_conv_price.C2, 2)
                      : 0,
                  selling_conv_price_c1:
                    res.selling_conv_price &&
                    res.selling_conv_price.C1 != undefined
                      ? this.formatNumber(res.selling_conv_price.C1, 2)
                      : 0,
                  selling_conv_price_c0:
                    res.selling_conv_price &&
                    res.selling_conv_price.C0 != undefined
                      ? this.formatNumber(res.selling_conv_price.C0, 2)
                      : 0,
                  selling_conv_price_sr:
                    res.selling_conv_price &&
                    res.selling_conv_price.SR != undefined
                      ? this.formatNumber(res.selling_conv_price.SR, 2)
                      : 0,
                  selling_conv_price_ss:
                    res.selling_conv_price &&
                    res.selling_conv_price.SS != undefined
                      ? this.formatNumber(res.selling_conv_price.SS, 2)
                      : 0,
                  selling_conv_price_b1:
                    res.selling_conv_price &&
                    res.selling_conv_price["B1-MT"] != undefined
                      ? this.formatNumber(res.selling_conv_price["B1-MT"], 2)
                      : 0,
                  selling_conv_price_b2:
                    res.selling_conv_price &&
                    res.selling_conv_price["B2-MT"] != undefined
                      ? this.formatNumber(res.selling_conv_price["B2-MT"], 2)
                      : 0,
                },
                percent: {
                  percent_a3: percent_a3 ? percent_a3 : "0",
                  percent_a2: percent_a2 ? percent_a2 : "0",
                  percent_a1: percent_a1 ? percent_a1 : "0",
                  percent_c3: percent_c3 ? percent_c3 : "0",
                  percent_c2: percent_c2 ? percent_c2 : "0",
                  percent_c1: percent_c1 ? percent_c1 : "0",
                  percent_c0: percent_c0 ? percent_c0 : "0",
                  percent_sr: percent_sr ? percent_sr : "0",
                  percent_ss: percent_ss ? percent_ss : "0",
                  percent_b1: percent_b1 ? percent_b1 : "0",
                  percent_b2: percent_b2 ? percent_b2 : "0",
                },
                mtime: mtime,
                effective_date: effective_date,
                expiry_date: expiry_date,
                cost: cost,
                cost_conv: cost_conv,
              });
            }
          })
          .catch();
      }
      this.tbPricingListLog = vDataPercent;
      // console.log("this.tbPricingListLog ==>", this.tbPricingListLog);

      //   this.loadData = false;
    },
    showPoint(value, pos) {
      if (isNaN(parseFloat(value))) {
        return value;
      } else {
        let rs = 0;
        if (value % 1 == 0) {
          rs = parseFloat(value).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        } else {
          let parts = value.toString().split(".");
          let num = (parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","));
          let digit = parts[1].slice(0, 2);
          digit = digit.length < 2 ? digit + "0" : digit;
          rs = num + "." + digit;
        }
        var result = rs.split(".");
        if (pos == "front") {
          return result[0];
        } else {
          return "." + result[1];
        }
      }
    },
    formatNumber(value, dicimal) {
      if (isNaN(parseFloat(value))) {
        return value;
      } else {
        if (value % 1 == 0) {
          return parseFloat(value).toLocaleString(undefined, {
            minimumFractionDigits: dicimal,
            maximumFractionDigits: dicimal,
          });
        } else {
          let parts = value.toString().split(".");
          let num = (parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","));
          let rs = num;
          if (parts.length > 1) {
            let digit = parts[1].slice(0, 3);
            digit = digit.length < 2 ? digit + "0" : digit;
            rs = num + "." + digit;
          }
          let comma = parseFloat(rs.replace(",", ""));
          // return Math.round(parseFloat(comma) * 100) / 100;
          return parseFloat(
            Math.round(parseFloat(comma) * 100) / 100
          ).toLocaleString(undefined, {
            minimumFractionDigits: dicimal,
            maximumFractionDigits: dicimal,
          });
        }
      }
    },
    filterData() {
      this.$emit("filterData", true);
    },
    deleteFilter(items, index) {
      // this.vChipsFilter.splice(index, 1);
      let tmpArr = [];
      for (let i = 0; i < this.vChipsFilter.length; i++) {
        if (i < index) {
          tmpArr.push(this.vChipsFilter[i]);
        }
      }
      this.vChipsFilter = tmpArr;
      this.$emit("clearFilter", items);
    },
    handleScroll(event) {
      if (
        event.target.scrollTop + event.target.clientHeight >=
        event.target.scrollHeight
      ) {
        this.$emit("handleScroll", {
          start: this.tbPricingList.length,
          length: 20,
        });
      }
    },
    onChangeSearch(type) {
      if (this.searchList.trim().split(" ").length > 488) {
        this.dContent = "Search limit of 488 item code";
        this.showSnackbar = true;
        return;
      } else {
        if (this.searchList.length > 3 || this.searchList == "") {
          let vSearch = "";
          if (this.checkSearch == 0) {
            vSearch = "code";
          } else if (this.checkSearch == 1) {
            vSearch = "name";
            // } else {
            // vSearch = 'all'
          }
          this.$emit("search", {
            optWarning: this.optWarning,
            slcSearch: this.slcSearch,
            search: vSearch,
            keyword: this.searchList,
            type: this.dataFilter ? this.dataFilter.type : "",
            group: this.dataFilter ? this.dataFilter.group : "",
            subGroup: this.dataFilter ? this.dataFilter.subGroup : "",
            cg: this.dataFilter ? this.dataFilter.cg : "",
            start: 0,
            length: 20,
          });
          this.iprodOld = "";
        }
      }

      // if (this.searchList == "") {
      //     this.$emit("search", {
      //         keyword: this.searchList,
      //         type: this.dataFilter ? this.dataFilter.type : "",
      //         group: this.dataFilter ? this.dataFilter.group : "",
      //         subGroup: this.dataFilter ? this.dataFilter.subGroup : "",
      //         cg: this.dataFilter ? this.dataFilter.cg : ""
      //     });
      //     this.iprodOld = "";
      // }
    },
    // trigger_upload() {
    //     this.$refs.fileInput.click();
    // },
    dialogClose() {
      if (this.$refs.fileInput !== undefined) {
        this.$refs.fileInput.value = "";
      }
    },
    onClose() {
      this.checkBackdrop = false;
    },
    importCancel() {
      this.checkBackdrop = false;
      this.showDialog = false;
    },
    fileDelete() {
      this.checkBackdrop = false;
      // this.showDialog = false;

      this.loading = true;
      PricingService.deleteFilePriceList(this.fileIdDelete).then((response) => {
        this.loading = false;
        if (!response.status) {
          this.dContent = "Delete file unsuccessfully. " + response.msg;
          this.showSnackbar = true;
        } else {
          let index = this.listImport
            .map(function (e) {
              return e.id;
            })
            .indexOf(this.fileIdDelete);
          if (index > -1) {
            this.listImport.splice(index, 1);
          }

          this.dContent =
            "Delete file '" + this.fileNameDelete + "' successfully.";
          this.showSnackbar = true;
        }
      });
    },
    importConfirm() {
      // let vm = this;
      // PricingService.saveImport(this.tbPricingListImport, this.eff_date)
      //     .then(response => {
      //         vm.showDialog = false;
      //         if (response == true) {
      //             this.$emit("count", {});
      //             this.$emit("search", {
      //                 keyword: this.searchList
      //             });
      //         }
      //     })
      //     .catch();

      this.checkBackdrop = false;
      // this.showDialog = false;
      // this.loading = true;
      this.loadingPopup = true;
      let eff_date = moment(this.eff_date).format("YYYY-MM-DD");

      var now_date = moment();
      var select_date = moment(eff_date);

      if (now_date >= select_date) {
        this.dContent = "Effective Date must be greater than current date.";
        this.showSnackbar = true;
        // this.loading = false;
        this.loadingPopup = false;
        return;
      } else {
        let dataImport = {
          id: this.fileID,
          eff_date: eff_date,
        };
        this.showDialog = false;
        PricingService.importPriceList(dataImport).then((response) => {
          // this.loading = false;
          this.loadingPopup = false;
          // console.log("response.error ==", response.error[0]);
          if (!response.status) {
            if (response.spawn) {
              this.dContent = response.spawn;
              this.showSnackbar = true;
            } else {
              this.showMsgImport = true;
              this.listError = response.error;
              //this.dContent = "Please check file import.";
            }
            return false;
          } else {
            this.dContent = "Import data successfully.";
            this.showSnackbar = true;
          }
        });
      }
    },
    importCancel() {
      this.showDialog = false;
    },
    // browseFile(e) {
    //     this.modeDialog = "browseFile";
    //     var data_list = [];
    //     var msg_validate = [];
    //     var vm = this;
    //     vm.tbPricingListImport = [];
    //     if (window.FileReader) {
    //         var files = e.target.files,
    //             i,
    //             f;
    //         let allowedExtensions = /(\.csv|.xlsx)$/i;
    //         if (!allowedExtensions.exec(files[0].name)) {
    //             //alert('Please upload file having extension .csv only.');
    //             alert('Invalid "File" format, correct format for .csv file');
    //             return false;
    //         }
    //         f = files[0];
    //         var reader = new FileReader(),
    //             name = f.name;
    //         var ext = name.split(".");
    //         if (ext[1] == "xlsx") {
    //             reader.readAsArrayBuffer(f);

    //             reader.onload = function (e) {
    //                 var results = null;
    //                 var filedata = e.target.result;
    //                 var fixedData = vm.fixdata(filedata);
    //                 var workbook = XLSX.read(btoa(fixedData), {
    //                     type: "base64"
    //                 });
    //                 var firstSheetName = workbook.SheetNames[0];
    //                 var worksheet = workbook.Sheets[firstSheetName];
    //                 results = XLSX.utils.sheet_to_json(worksheet, {
    //                     header: 1
    //                 });
    //                 results = results.slice(1);
    //                 let product_ids = "";
    //                 let arr_product_id = [];
    //                 vm.importConfirmDisable = true;
    //                 for (let i = 0; i < results.length; i++) {
    //                     let code = results[i][0].replace(/"/g, "").trim();
    //                     code = code.substr(0, 1) === "'" ? code.substr(1) : code;
    //                     product_ids += code + ",";
    //                 }
    //                 PricingService.getProduct(product_ids)
    //                     .then(response => {
    //                         let products_detail = [];
    //                         for (let i = 0; i < response.length; i++) {
    //                             products_detail[response[i].code] = response[i];
    //                         }

    //                         for (let index = 0; index < results.length; index++) {
    //                             let row = results[index];
    //                             let err_product = "";
    //                             let title = "";
    //                             let num = index + 1;
    //                             if (row.length < 6) {
    //                                 continue;
    //                             }
    //                             if (row[0] === undefined) {
    //                                 row[0] = "";
    //                             }
    //                             if (row[1] === undefined) {
    //                                 row[1] = "";
    //                             }
    //                             if (row[2] === undefined) {
    //                                 row[2] = "";
    //                             }
    //                             if (row[3] === undefined) {
    //                                 row[3] = "";
    //                             }
    //                             if (row[4] === undefined) {
    //                                 row[4] = "";
    //                             }
    //                             if (row[5] === undefined) {
    //                                 row[5] = "";
    //                             }

    //                             let code = row[0]
    //                                 .trim()
    //                                 .replace(/"/g, "")
    //                                 .trim();
    //                             let product_code =
    //                                 code != "" &&
    //                                 (code.substr(0, 1) === "'" ||
    //                                     code.substr(0, 1) === "‘" ||
    //                                     code.substr(0, 1) === "’") ?
    //                                 code.substr(1) :
    //                                 code;
    //                             if (product_code === "") {
    //                                 err_product = "Product Code is not allowed to be empty.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: "",
    //                                     msg: err_product
    //                                 });
    //                             } else if (arr_product_id.indexOf(product_code) >= 0) {
    //                                 err_product =
    //                                     "Product Code dupilcate reccord in excel files.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             } else if (
    //                                 product_code.length !== 6 &&
    //                                 product_code.length !== 8
    //                             ) {
    //                                 err_product = "Product Code lenght 6 or 8 digi only.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             } else if (products_detail[product_code] === undefined) {
    //                                 err_product = "Product Code not exist in system.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             } else if (
    //                                 products_detail[product_code] !== undefined &&
    //                                 products_detail[product_code].status !== "Active"
    //                             ) {
    //                                 err_product = "Product Code status is disable.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             } else {
    //                                 arr_product_id.push(product_code);
    //                                 title = products_detail[product_code].title_th;
    //                             }
    //                             if (row[1].trim() === "") {
    //                                 err_product = 'Price "A1" is not allowed to be empty.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             } else if (!vm.isNumber(row[1].trim())) {
    //                                 err_product = 'Price "A1" invalid format.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }
    //                             if (row[2].trim() === "") {
    //                                 err_product = 'Price "A3" is not allowed to be empty.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             } else if (!vm.isNumber(row[2].trim())) {
    //                                 err_product = 'Price "A3" invalid format.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }
    //                             if (row[3].trim() === "") {
    //                                 err_product = 'Price "C2" is not allowed to be empty.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             } else if (!vm.isNumber(row[3].trim())) {
    //                                 err_product = 'Price "C2" invalid format.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }
    //                             if (row[4].trim() === "") {
    //                                 err_product = 'Price "C1" is not allowed to be empty.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             } else if (!vm.isNumber(row[4].trim())) {
    //                                 err_product = 'Price "C1" invalid format.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }
    //                             if (row[5].trim() === "") {
    //                                 err_product = 'Price "C0" is not allowed to be empty.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             } else if (!vm.isNumber(row[5].trim())) {
    //                                 err_product = 'Price "C0" invalid format.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }

    //                             if (row[3].trim() < row[4].trim()) {
    //                                 err_product = "C2 value is lower than C1 values.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }
    //                             if (row[3].trim() < row[5].trim()) {
    //                                 err_product = "C2 value is lower than C0 values.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }
    //                             if (row[4].trim() < row[5].trim()) {
    //                                 err_product = "C1 value is lower than C0 values.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }
    //                             if (row[2].trim() < row[3].trim()) {
    //                                 err_product = "A3 value is lower than C2 values.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }
    //                             if (row[2].trim() < row[4].trim()) {
    //                                 err_product = "A3 value is lower than C1 values.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }
    //                             if (row[2].trim() < row[5].trim()) {
    //                                 err_product = "A3 value is lower than C0 values.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }

    //                             let row_alert = err_product === "" ? "" : "color:red";
    //                             let selling_um_conv =
    //                                 products_detail[product_code] &&
    //                                 products_detail[product_code].selling_um_conv != null ?
    //                                 products_detail[product_code].selling_um_conv :
    //                                 "";

    //                             let temp = {
    //                                 iprod: product_code,
    //                                 title_th: title,
    //                                 selling_um: products_detail[product_code] ?
    //                                     products_detail[product_code].selling_um : "",
    //                                 selling_um_conv: products_detail[product_code] ?
    //                                     products_detail[product_code].selling_um_conv : "",
    //                                 selling_um_title: products_detail[product_code] ?
    //                                     products_detail[product_code].selling_um_title : "",
    //                                 old_price_a1: vm.formatNumber(row[1].trim(), 2),
    //                                 old_price_a3: vm.formatNumber(row[2].trim(), 2),
    //                                 old_price_c2: vm.formatNumber(row[3].trim(), 2),
    //                                 old_price_c1: vm.formatNumber(row[4].trim(), 2),
    //                                 old_price_c0: vm.formatNumber(row[5].trim(), 2),
    //                                 price_a1: parseFloat(row[1].trim()).toFixed(4),
    //                                 price_a3: parseFloat(row[2].trim()).toFixed(4),
    //                                 price_c2: parseFloat(row[3].trim()).toFixed(4),
    //                                 price_c1: parseFloat(row[4].trim()).toFixed(4),
    //                                 price_c0: parseFloat(row[5].trim()).toFixed(4),
    //                                 row_css: row_alert,
    //                                 price_a1_selling: selling_um_conv != "" ?
    //                                     parseFloat(row[1].trim() * selling_um_conv).toFixed(4) : "",
    //                                 price_a3_selling: selling_um_conv != "" ?
    //                                     parseFloat(row[2].trim() * selling_um_conv).toFixed(4) : "",
    //                                 price_c2_selling: selling_um_conv != "" ?
    //                                     parseFloat(row[3].trim() * selling_um_conv).toFixed(4) : "",
    //                                 price_c1_selling: selling_um_conv != "" ?
    //                                     parseFloat(row[4].trim() * selling_um_conv).toFixed(4) : "",
    //                                 price_c0_selling: selling_um_conv != "" ?
    //                                     parseFloat(row[5].trim() * selling_um_conv).toFixed(4) : ""
    //                             };
    //                             data_list.push(temp);
    //                             vm.tbPricingListImport.push(temp);
    //                         }

    //                         if (data_list.length > 0) {
    //                             vm.showDialog = true;
    //                             let tomorrow = new Date();
    //                             tomorrow.setDate(tomorrow.getDate() + 1);
    //                             let dd = tomorrow.getDate(),
    //                                 mm = tomorrow.getMonth() + 1,
    //                                 yyyy = tomorrow.getFullYear();
    //                             if (dd < 10) {
    //                                 dd = "0" + dd;
    //                             }
    //                             if (mm < 10) {
    //                                 mm = "0" + mm;
    //                             }
    //                             vm.eff_date = yyyy + "-" + mm + "-" + dd;
    //                         } else {
    //                             alert("Dot't have data or format file incorrect.");
    //                             return false;
    //                         }
    //                         vm.price_updates = data_list.length;
    //                         if (msg_validate.length > 0) {
    //                             vm.tbMessageImport = msg_validate;
    //                             vm.showMsgImport = true;
    //                         } else {
    //                             vm.importConfirmDisable = false;
    //                         }
    //                     })
    //                     .catch();
    //             };
    //         } else {
    //             //                    if (ext[1] == "csv") {
    //             //reader.readAsText(e.target.files[i]);
    //             reader.readAsText(f);

    //             reader.onload = function (e) {
    //                 var results = null;
    //                 var csv = e.target.result;

    //                 var lines = csv.split("\r\n");
    //                 /*results = lines.slice(0, -1);*/
    //                 results = lines.slice(1);
    //                 //console.log(this.datacsv)
    //                 //                            console.info('slice', results);
    //                 //                            results = results.map((data) => {
    //                 //                                return [data]
    //                 //                            })

    //                 let product_ids = "";
    //                 let arr_product_id = [];
    //                 vm.importConfirmDisable = true;
    //                 for (let i = 0; i < results.length; i++) {
    //                     let line = results[i].split(",");
    //                     let code = line[0].replace(/"/g, "").trim();
    //                     code = code.substr(0, 1) === "'" ? code.substr(1) : code;
    //                     //product_ids += line[0].trim() + ",";
    //                     product_ids += code + ",";
    //                 }
    //                 PricingService.getProduct(product_ids)
    //                     .then(response => {
    //                         // this.product = response;
    //                         let products_detail = [];
    //                         for (let i = 0; i < response.length; i++) {
    //                             products_detail[response[i].code] = response[i];
    //                         }

    //                         for (let index = 0; index < results.length; index++) {
    //                             let row = results[index].split(",");
    //                             let err_product = "";
    //                             let title = "";
    //                             let num = index + 1;
    //                             if (row.length < 6) {
    //                                 //if (row.length !== 6) {
    //                                 continue;
    //                             }

    //                             let code = row[0]
    //                                 .trim()
    //                                 .replace(/"/g, "")
    //                                 .trim();
    //                             let product_code =
    //                                 code != "" &&
    //                                 (code.substr(0, 1) === "'" ||
    //                                     code.substr(0, 1) === "‘" ||
    //                                     code.substr(0, 1) === "’") ?
    //                                 code.substr(1) :
    //                                 code;
    //                             if (product_code === "") {
    //                                 err_product = "Product Code is not allowed to be empty.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: "",
    //                                     msg: err_product
    //                                 });
    //                             } else if (arr_product_id.indexOf(product_code) >= 0) {
    //                                 err_product =
    //                                     "Product Code dupilcate reccord in excel files.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             } else if (
    //                                 product_code.length !== 6 &&
    //                                 product_code.length !== 8
    //                             ) {
    //                                 err_product = "Product Code lenght 6 or 8 digi only.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             } else if (products_detail[product_code] === undefined) {
    //                                 err_product = "Product Code not exist in system.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             } else if (
    //                                 products_detail[product_code] !== undefined &&
    //                                 products_detail[product_code].status !== "Active"
    //                             ) {
    //                                 err_product = "Product Code status is disable.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             } else {
    //                                 arr_product_id.push(product_code);
    //                                 title = products_detail[product_code].title_th;
    //                             }

    //                             if (row[1].trim() === "") {
    //                                 err_product = 'Price "A1" is not allowed to be empty.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             } else if (!vm.isNumber(row[1].trim())) {
    //                                 err_product = 'Price "A1" invalid format.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }
    //                             if (row[2].trim() === "") {
    //                                 err_product = 'Price "A3" is not allowed to be empty.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             } else if (!vm.isNumber(row[2].trim())) {
    //                                 err_product = 'Price "A3" invalid format.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }
    //                             if (row[3].trim() === "") {
    //                                 err_product = 'Price "C2" is not allowed to be empty.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             } else if (!vm.isNumber(row[3].trim())) {
    //                                 err_product = 'Price "C2" invalid format.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }
    //                             if (row[4].trim() === "") {
    //                                 err_product = 'Price "C1" is not allowed to be empty.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             } else if (!vm.isNumber(row[4].trim())) {
    //                                 err_product = 'Price "C1" invalid format.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }
    //                             if (row[5].trim() === "") {
    //                                 err_product = 'Price "C0" is not allowed to be empty.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             } else if (!vm.isNumber(row[5].trim())) {
    //                                 err_product = 'Price "C0" invalid format.';
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }

    //                             if (row[3].trim() < row[4].trim()) {
    //                                 err_product = "C2 value is lower than C1 values.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }
    //                             if (row[3].trim() < row[5].trim()) {
    //                                 err_product = "C2 value is lower than C0 values.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }
    //                             if (row[4].trim() < row[5].trim()) {
    //                                 err_product = "C1 value is lower than C0 values.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }
    //                             if (row[2].trim() < row[3].trim()) {
    //                                 err_product = "A3 value is lower than C2 values.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }
    //                             if (row[2].trim() < row[4].trim()) {
    //                                 err_product = "A3 value is lower than C1 values.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }
    //                             if (row[2].trim() < row[5].trim()) {
    //                                 err_product = "A3 value is lower than C0 values.";
    //                                 msg_validate.push({
    //                                     row: num,
    //                                     code: product_code,
    //                                     msg: err_product
    //                                 });
    //                             }
    //                             //                                if (
    //                             //                                    row[3].trim() < row[4].trim() ||
    //                             //                                    row[4].trim() < row[5].trim()
    //                             //                                ) {
    //                             //                                    err_product = "Invalid price format.";
    //                             //                                    msg_validate.push({
    //                             //                                        row: num,
    //                             //                                        code: product_code,
    //                             //                                        msg: err_product
    //                             //                                    });
    //                             //                                }

    //                             let row_alert = err_product === "" ? "" : "color:red";
    //                             let selling_um_conv =
    //                                 products_detail[product_code] &&
    //                                 products_detail[product_code].selling_um_conv != null ?
    //                                 products_detail[product_code].selling_um_conv :
    //                                 "";

    //                             let temp = {
    //                                 iprod: product_code,
    //                                 title_th: title,
    //                                 selling_um: products_detail[product_code] ?
    //                                     products_detail[product_code].selling_um : "",
    //                                 selling_um_conv: products_detail[product_code] ?
    //                                     products_detail[product_code].selling_um_conv : "",
    //                                 selling_um_title: products_detail[product_code] ?
    //                                     products_detail[product_code].selling_um_title : "",
    //                                 old_price_a1: vm.formatNumber(row[1].trim(), 2),
    //                                 old_price_a3: vm.formatNumber(row[2].trim(), 2),
    //                                 old_price_c2: vm.formatNumber(row[3].trim(), 2),
    //                                 old_price_c1: vm.formatNumber(row[4].trim(), 2),
    //                                 old_price_c0: vm.formatNumber(row[5].trim(), 2),
    //                                 price_a1: parseFloat(row[1].trim()).toFixed(4),
    //                                 price_a3: parseFloat(row[2].trim()).toFixed(4),
    //                                 price_c2: parseFloat(row[3].trim()).toFixed(4),
    //                                 price_c1: parseFloat(row[4].trim()).toFixed(4),
    //                                 price_c0: parseFloat(row[5].trim()).toFixed(4),
    //                                 row_css: row_alert,
    //                                 price_a1_selling: selling_um_conv != "" ?
    //                                     parseFloat(row[1].trim() * selling_um_conv).toFixed(4) : "",
    //                                 price_a3_selling: selling_um_conv != "" ?
    //                                     parseFloat(row[2].trim() * selling_um_conv).toFixed(4) : "",
    //                                 price_c2_selling: selling_um_conv != "" ?
    //                                     parseFloat(row[3].trim() * selling_um_conv).toFixed(4) : "",
    //                                 price_c1_selling: selling_um_conv != "" ?
    //                                     parseFloat(row[4].trim() * selling_um_conv).toFixed(4) : "",
    //                                 price_c0_selling: selling_um_conv != "" ?
    //                                     parseFloat(row[5].trim() * selling_um_conv).toFixed(4) : ""
    //                             };
    //                             data_list.push(temp);
    //                             vm.tbPricingListImport.push(temp);
    //                         }

    //                         if (data_list.length > 0) {
    //                             vm.showDialog = true;
    //                             let tomorrow = new Date();
    //                             tomorrow.setDate(tomorrow.getDate() + 1);
    //                             let dd = tomorrow.getDate(),
    //                                 mm = tomorrow.getMonth() + 1,
    //                                 yyyy = tomorrow.getFullYear();
    //                             if (dd < 10) {
    //                                 dd = "0" + dd;
    //                             }
    //                             if (mm < 10) {
    //                                 mm = "0" + mm;
    //                             }
    //                             vm.eff_date = yyyy + "-" + mm + "-" + dd;
    //                         } else {
    //                             alert("Dot't have data or format file incorrect.");
    //                             return false;
    //                         }
    //                         vm.price_updates = data_list.length;

    //                         if (msg_validate.length > 0) {
    //                             vm.tbMessageImport = msg_validate;
    //                             vm.showMsgImport = true;
    //                         } else {
    //                             vm.importConfirmDisable = false;
    //                         }
    //                     })
    //                     .catch();

    //                 //                            vm.getProducts(results);
    //             };
    //             //console.log(csvJSON(csv))
    //             //                    }
    //             /*else if (ext[1] == "xlsx" || ext[1] == "xls") {
    //                                           reader.readAsArrayBuffer(f);
    //                                           reader.onload = function (e) {
    //                                               var results,
    //                                                   data = e.target.result,
    //                                                   fixedData = vm.fixdata(data),
    //                                                   workbook = XLSX.read(btoa(fixedData), {
    //                                                       type: "base64"
    //                                                   }),
    //                                                   firstSheetName = workbook.SheetNames[0],
    //                                                   worksheet = workbook.Sheets[firstSheetName];
    //                                               //this.headers = vm.get_header_row(worksheet);
    //                                               results = XLSX.utils.sheet_to_json(worksheet, {
    //                                                   header: 1
    //                                               });
    //                                               // this.dataExcelImport = results;

    //                                               vm.getProducts(results);
    //                                               //console.log(this.tickets);
    //                                           };
    //                                       }*/
    //             //                }
    //         }
    //     } else {
    //         alert("FileReader are not supported in this browser.");
    //     }
    // },
    fixdata(data) {
      var o = "",
        l = 0,
        w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    isNumber(n) {
      "use strict";
      n = n.replace(/\./g, "").replace(",", ".");
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    // export_format() {
    //   let template = [
    //     {
    //       code: "000059",
    //       price: { A1: 10000000.599, A3: 90, C0: 49, C1: 50, C2: 80 }
    //     },
    //     {
    //       code: "000172",
    //       price: { A1: 1000.49, A3: 90, C0: 40, C1: 50, C2: 80 }
    //     },
    //     { code: "000301", price: { A1: 50, A3: 48.0, C0: 35, C1: 40, C2: 45 } },
    //     { code: "000615", price: { A1: 50, A3: 48.0, C0: 35, C1: 40, C2: 45 } },
    //     { code: "002343", price: { A1: 50, A3: 48.0, C0: 35, C1: 40, C2: 45 } }
    //   ];
    //   let json_template = [];
    //   let self = this;
    //   for (let i = 0; i <= 500; i++) {
    //     let a1 = "",
    //       a3 = "",
    //       c2 = "",
    //       c1 = "",
    //       c0 = "";
    //     if (template[i] !== undefined && template[i].price) {
    //       a1 = self.formatNumber(template[i].price.A1, 2);
    //       a3 = self.formatNumber(template[i].price.A3, 2);
    //       c2 = self.formatNumber(template[i].price.C2, 2);
    //       c1 = self.formatNumber(template[i].price.C1, 2);
    //       c0 = self.formatNumber(template[i].price.C0, 2);
    //     }
    //     json_template.push({
    //       Code: template[i] === undefined ? "" : "'" + template[i].code,
    //       A1: {
    //         t: "n",
    //         v:
    //           template[i] &&
    //           template[i].price &&
    //           template[i].price.A1 != undefined
    //             ? a1.replace(/,/g, "")
    //             : "",
    //         z: "#0.00"
    //       },
    //       A3: {
    //         t: "n",
    //         v:
    //           template[i] &&
    //           template[i].price &&
    //           template[i].price.A3 != undefined
    //             ? a3.replace(/,/g, "")
    //             : "",
    //         z: "#0.00"
    //       },
    //       C2: {
    //         t: "n",
    //         v:
    //           template[i] &&
    //           template[i].price &&
    //           template[i].price.C2 != undefined
    //             ? c2.replace(/,/g, "")
    //             : "",
    //         z: "#0.00"
    //       },
    //       C1: {
    //         t: "n",
    //         v:
    //           template[i] &&
    //           template[i].price &&
    //           template[i].price.C1 != undefined
    //             ? c1.replace(/,/g, "")
    //             : "",
    //         z: "#0.00"
    //       },
    //       C0: {
    //         t: "n",
    //         v:
    //           template[i] &&
    //           template[i].price &&
    //           template[i].price.C0 != undefined
    //             ? c0.replace(/,/g, "")
    //             : "",
    //         z: "#0.00"
    //       }
    //     });
    //   }
    //   if (json_template.length > 0) {
    //     this.ExportExcelFormat(json_template, "Export_price_", true);
    //   }
    // },
    export_excel(isXLSX = false) {
      if (
        (this.dataFilter.type === undefined || this.dataFilter.type == "") &&
        (this.dataFilter.group === undefined || this.dataFilter.group == "") &&
        (this.dataFilter.subGroup === undefined ||
          this.dataFilter.subGroup == "") &&
        (this.dataFilter.cg === undefined || this.dataFilter.cg == "") &&
        this.searchList == ""
      ) {
        this.dContent = "Please filter data.";
        this.showSnackbar = true;
        this.loading = false;
        return false;
      }

      this.loadExport = true;
      this.json_data = [];
      this.json_data_excel = [];
      let self = this;
      let vSearch = "";
      if (this.checkSearch == 0) {
        vSearch = "code";
      } else if (this.checkSearch == 1) {
        vSearch = "name";
        // } else {
        //     vSearch = 'all'
      }

      let dataSearch = {
        search: vSearch,
        keyword: this.searchList.length > 2 ? this.searchList : "",
        type: this.dataFilter ? this.dataFilter.type : "",
        group: this.dataFilter ? this.dataFilter.group : "",
        subGroup: this.dataFilter ? this.dataFilter.subGroup : "",
        cg: this.dataFilter ? this.dataFilter.cg : "",
        start: 0,
        limit: parseInt(this.total_all_int),
        // limit: 25
      };
      let emp_code = this.$jwt.decode(localStorage.getItem("token")).code;
      dataSearch.emp_code = emp_code;
      PricingService.getPriceList(this.valueTab, dataSearch, "export")
        .then((response) => {
          if (response) {
            response.forEach(function (value, key) {
              let a1 = "",
                a3 = "",
                c2 = "",
                c1 = "",
                c0 = "",
                c3 = "",
                a2 = "",
                sr = "",
                ss = "";
              if (value.price) {
                a1 = self.formatNumber(value.selling_conv_price.A1, 2);
                a3 = self.formatNumber(value.selling_conv_price.A3, 2);
                c2 = self.formatNumber(value.selling_conv_price.C2, 2);
                c1 = self.formatNumber(value.selling_conv_price.C1, 2);
                c0 = self.formatNumber(value.selling_conv_price.C0, 2);
                c3 = self.formatNumber(value.selling_conv_price.C3, 2);
                a2 = self.formatNumber(value.selling_conv_price.A2, 2);
                sr = self.formatNumber(value.selling_conv_price.SR, 2);
                ss = self.formatNumber(value.selling_conv_price.SS, 2);
              }
              let desc = "";
              if (value.title_th !== undefined && value.title_th !== "") {
                desc = value.title_th;
              } else if (value.title !== undefined && value.title !== "") {
                desc = value.title;
              }
              if (isXLSX === true) {
                self.json_data_excel.push({
                  Code:
                    self.valueTab == "UPCOMING"
                      ? "'" + value.iprod
                      : "'" + value.code,
                  Title: value.title_th != undefined ? value.title_th : "",
                  A1: {
                    t: "n",
                    v:
                      value.price && value.price.A1 != undefined
                        ? a1.replace(/,/g, "")
                        : "",
                    z: "#0.00",
                  },
                  A3: {
                    t: "n",
                    v:
                      value.price && value.price.A3 != undefined
                        ? a3.replace(/,/g, "")
                        : "",
                    z: "#0.00",
                  },
                  C2: {
                    t: "n",
                    v:
                      value.price && value.price.C2 != undefined
                        ? c2.replace(/,/g, "")
                        : "",
                    z: "#0.00",
                  },
                  C1: {
                    t: "n",
                    v:
                      value.price && value.price.C1 != undefined
                        ? c1.replace(/,/g, "")
                        : "",
                    z: "#0.00",
                  },
                  C0: {
                    t: "n",
                    v:
                      value.price && value.price.C0 != undefined
                        ? c0.replace(/,/g, "")
                        : "",
                    z: "#0.00",
                  },
                  SR: {
                    t: "n",
                    v:
                      value.price && value.price.SR != undefined
                        ? sr.replace(/,/g, "")
                        : "",
                    z: "#0.00",
                  },
                  SS: {
                    t: "n",
                    v:
                      value.price && value.price.SS != undefined
                        ? ss.replace(/,/g, "")
                        : "",
                    z: "#0.00",
                  },
                  Type:
                    value.productype_code != undefined
                      ? value.productype_code
                      : "",
                  Type_title:
                    value.productype_title != undefined
                      ? value.productype_title
                      : "",
                  Group:
                    value.productgroup_code != undefined
                      ? value.productgroup_code
                      : "",
                  Group_title:
                    value.productgroup_title != undefined
                      ? value.productgroup_title
                      : "",
                  Subgroup:
                    value.productsubgroup_code != undefined
                      ? value.productsubgroup_code
                      : "",
                  Subgroup_title:
                    value.productsubgroup_title != undefined
                      ? value.productsubgroup_title
                      : "",
                  CG:
                    value.productcg_code != undefined
                      ? value.productcg_code
                      : "",
                  CG_title:
                    value.productcg_title != undefined
                      ? value.productcg_title
                      : "",
                  lifecycle:
                    value.productlifecycle_code != undefined
                      ? value.productlifecycle_code
                      : "",
                  lifecycle_title:
                    value.productlifecycle_title != undefined
                      ? value.productlifecycle_title
                      : "",
                  pmd:
                    value.productpmd_code != undefined
                      ? value.productpmd_code
                      : "",
                  pmd_title:
                    value.productpmd_title != undefined
                      ? value.productpmd_title
                      : "",
                });
              } else {
                self.json_data.push({
                  Type:
                    value.productype_code != undefined
                      ? "'" + value.productype_code
                      : "",
                  Group:
                    value.productgroup_code != undefined
                      ? "'" + value.productgroup_code
                      : "",
                  Subgroup:
                    value.productsubgroup_code != undefined
                      ? "'" + value.productsubgroup_code
                      : "",
                  CG:
                    value.productcg_code != undefined
                      ? "'" + value.productcg_code
                      : "",
                  Item_Code:
                    self.valueTab == "UPCOMING"
                      ? "'" + value.iprod
                      : "'" + value.code,
                  Description: desc,
                  Selling_Unit:
                    value.selling_um_title !== undefined
                      ? value.selling_um_title
                      : "",
                  Selling_Conv:
                    value.selling_um_conv !== undefined
                      ? value.selling_um_conv
                      : "",
                  A3:
                    value.price && value.selling_conv_price.A3 != undefined
                      ? a3.replace(/,/g, "")
                      : "",
                  A2:
                    value.price && value.selling_conv_price.A2 != undefined
                      ? a2.replace(/,/g, "")
                      : "",
                  A1:
                    value.price && value.selling_conv_price.A1 != undefined
                      ? a1.replace(/,/g, "")
                      : "",
                  C3:
                    value.price && value.selling_conv_price.C3 != undefined
                      ? c3.replace(/,/g, "")
                      : "",
                  C2:
                    value.price && value.selling_conv_price.C2 != undefined
                      ? c2.replace(/,/g, "")
                      : "",
                  C1:
                    value.price && value.selling_conv_price.C1 != undefined
                      ? c1.replace(/,/g, "")
                      : "",
                  C0:
                    value.price && value.selling_conv_price.C0 != undefined
                      ? c0.replace(/,/g, "")
                      : "",
                  SR:
                    value.price && value.selling_conv_price.SR != undefined
                      ? sr.replace(/,/g, "")
                      : "",
                  SS:
                    value.price && value.selling_conv_price.SS != undefined
                      ? ss.replace(/,/g, "")
                      : "",
                });
              }
            });
            if (self.json_data.length > 0 || self.json_data_excel.length > 0) {
              if (isXLSX === true) {
                self.ExportExcelFormat(
                  self.json_data_excel,
                  "Product on Selling Price_",
                  true
                );
              } else {
                self.JSONToCSVConvertor(
                  self.json_data,
                  "Product on Selling Price_",
                  true
                );
              }
            } else {
              this.dContent = "Please select data for export.";
              this.showSnackbar = true;
            }
            this.loadExport = false;
          }
        })
        .catch();
      //            if (isXLSX === true) {
      //                if (this.json_data_excel.length > 0) {
      //                    console.log('@1');
      //                    this.ExportExcelFormat(this.json_data_excel, "Export_price_", true);
      //                } else {
      //                    console.log('@2');
      //                    this.dContent = "Please select data for export.";
      //                    this.showSnackbar = true;
      //                }
      //            } else {
      //                console.log('>>>>>>');
      //                if (this.json_data.length > 0) {
      //                    console.log('if');
      //                    this.JSONToCSVConvertor(this.json_data, "Export_price_", true);
      //                } else {
      //                    console.log('else');
      //                    this.dContent = "Please select data for export.";
      //                    this.showSnackbar = true;
      //                }
      //            }
      //            this.loadExport = false;
    },
    export_csv() {
      this.loading = true;
      if (
        (this.dataFilter.type === undefined || this.dataFilter.type == "") &&
        (this.dataFilter.group === undefined || this.dataFilter.group == "") &&
        (this.dataFilter.subGroup === undefined ||
          this.dataFilter.subGroup == "") &&
        (this.dataFilter.cg === undefined || this.dataFilter.cg == "") &&
        this.searchList == ""
      ) {
        this.dContent = "Please filter data.";
        this.showSnackbar = true;
        this.loading = false;
        return false;
      }

      let emp_code = this.$jwt.decode(localStorage.getItem("token")).code;
      let vSearch = "";
      if (this.checkSearch == 0) {
        vSearch = "code";
      } else if (this.checkSearch == 1) {
        vSearch = "name";
        // } else {
        //     vSearch = 'all'
      }

      let dataExport = {
        tab: this.valueTab,
        search: vSearch,
        keyword: this.searchList ? this.searchList : "",
        type: this.dataFilter ? this.dataFilter.type : "",
        group: this.dataFilter ? this.dataFilter.group : "",
        subGroup: this.dataFilter ? this.dataFilter.subGroup : "",
        cg: this.dataFilter ? this.dataFilter.cg : "",
        emp_code: emp_code,
      };

      PricingService.exportPriceList(dataExport).then((response) => {
        // console.log("response ==>", response);
        if (!response.status) {
          // if(this.dataFilter.group === undefined || this.dataFilter.group == "") {
          //     this.dContent = "Please select Product Group.";
          // } else if(this.dataFilter.subGroup === undefined || this.dataFilter.subGroup == "") {
          //     this.dContent = "Please select Product Sub Group.";
          // } else if(this.dataFilter.cg === undefined || this.dataFilter.cg == "") {
          //     this.dContent = "Please select Product CG.";
          // }

          if (response.error) {
            this.dContent = response.error;
          } else {
            this.dContent = "Please enter additional conditions.";
          }
          this.showSnackbar = true;
          this.loading = false;
          return false;
        } else {
          this.dContent = "Export data Successfully, Please check the email.";
          this.showSnackbar = true;
        }
        this.loading = false;
      });
    },
    import_file() {
      this.eff_date = "";
      this.fileID = "";
      this.checkBackdrop = false;
      this.loading = true;

      PricingService.checkDataImport().then((response) => {
        // console.log("response ==>", response);
        this.loading = false;
        if (!response.status) {
          this.dContent = "No user file found.";
          this.showSnackbar = true;
          return false;
        } else {
          this.modeDialog = "browseFile";
          this.importConfirmDisable = false;
          this.showDialog = true;

          // this.listImport = response.file;
          // console.log("response.file ==>", response.file);
          this.listImport = response.file.sort(function (a, b) {
            var keyA = new Date(a.modifiedTime),
              keyB = new Date(b.modifiedTime);
            if (keyA < keyB) return 1;
            if (keyA > keyB) return -1;
            return 0;
          });
        }
      });
    },
    selectFile(id) {
      this.fileID = id;
    },
    deleteFile(files) {
      this.fileIdDelete = files.id;
      this.fileNameDelete = files.name;
      this.checkBackdrop = true;
      this.delFileName =
        "Are you sure you want to delete " + this.fileNameDelete + " ?";
      this.dialogConfirmDelete = true;
    },
    cancelPopup() {
      this.checkBackdrop = true;
      this.dialogConfirmCancel = true;
    },
    confirmPopup() {
      if (this.eff_date == "") {
        this.dContent = "Please select effective date.";
        this.showSnackbar = true;
        return false;
      } else if (this.fileID == "") {
        this.dContent = "Please select file.";
        this.showSnackbar = true;
        return false;
      }
      this.checkBackdrop = true;
      this.dialogConfirmSave = true;
    },
    // ExportExcelFormat(JSONData, ReportTitle, ShowLabel) {
    //   var ws = XLSX.utils.json_to_sheet(JSONData);
    //   var wb = XLSX.utils.book_new();
    //   XLSX.utils.book_append_sheet(wb, ws, "-");

    //   var d = new Date();
    //   var month = d.getMonth() + 1;
    //   var day = d.getDate();
    //   var currentDate =
    //     d.getFullYear() +
    //     (month < 10 ? "0" : "") +
    //     month +
    //     (day < 10 ? "0" : "") +
    //     day;

    //   var fileName = ReportTitle + currentDate;

    //   XLSX.writeFile(wb, fileName + ".xlsx", {
    //     bookType: "xlsx",
    //     type: "base64"
    //   });
    // },
    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
    JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
      var arrData =
        typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;
      var CSV = "";
      //            CSV += ReportTitle + '\r\n\n';
      if (ShowLabel) {
        var row = "";
        for (var index in arrData[0]) {
          row += index + ",";
        }

        row = row.slice(0, -1);
        CSV += row + "\r\n";
      }

      for (var i = 0; i < arrData.length; i++) {
        let row = "";
        for (let index in arrData[i]) {
          // row += arrData[i][index] + ',';
          //                    if (index != "CG") {
          if (index != "SS") {
            row += arrData[i][index] + ",";
          } else {
            row += arrData[i][index];
          }
        }

        row.slice(0, row.length - 1);
        CSV += row + "\r\n";
      }

      if (CSV == "") {
        alert("Invalid data");
        return;
      }

      // var fileName = "MyReport_";
      // fileName += ReportTitle.replace(/ /g, "_");
      var d = new Date();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var currentDate =
        d.getFullYear() +
        (month < 10 ? "0" : "") +
        month +
        (day < 10 ? "0" : "") +
        day;

      var fileName = ReportTitle + currentDate;
      var uri = "data:text/csv;charset=utf-8," + encodeURIComponent(CSV);
      var link = document.createElement("a");
      link.href = uri;
      link.style = "visibility:hidden";
      link.download = fileName + ".csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style lang="scss">
#pricinglist {
  .md-layout-item {
    display: flex;

    .md-card.tab-table.md-theme-default {
      width: 100%;
    }

    // .export-csv {
    // height: 45px;
    // width: 130px;
    // position: relative;
    // padding-bottom: 15px;
    // }

    .import-file {
      display: none;
    }

    .pricing-head.mktops-subheader-filter {
      height: 38px;
      width: 100%;

      .md-field.box > .md-input.md-select-value,
      .md-field.box > .md-menu.md-select {
        font-size: 14px;
        // width: 115.72px;
        width: 100%;
        height: 36px;
        margin: 10px 9.28px 0 4px;
      }

      .md-field.md-field.box {
        margin-top: unset;
        margin-bottom: unset;
        padding: unset;
      }

      .md-field:after,
      .md-field:before {
        left: unset;
      }

      .md-field.box .md-input.md-input.md-select-value,
      .md-field.box label {
        font-size: 14px;
        padding-left: 12px;
        padding-top: 3px;
        color: #727272;
      }

      .md-field.box .md-select {
        background-color: #efefef;
        border-radius: 3px;
      }
    }

    .md-search-box {
      margin: 10px 0px 10px 0px;
      padding-top: unset;
      width: 100%;
      border-radius: 3px;
      min-height: 36px; // min-height: 5.3vmin;
      // max-height: 5.3vmin;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.16), 0 0 0 rgba(0, 0, 0, 0),
        0 1px 1px -2px rgba(0, 0, 0, 0);

      .md-icon.material-icons {
        margin-left: 10px; // padding-top: 8px;
        margin-top: 7px;
        color: rgba(0, 0, 0, 0.54); // font-size: 3.6vmin !important;
      }

      .md-input {
        height: 36px; // height: 5.3vmin;
        margin-left: 7px;
      }

      &.md-field > .md-icon:after,
      &.md-field:after,
      &.md-field:before {
        content: none;
      }
    }

    .md-icon-button {
      margin-top: 8px;
    }

    .layout-flex-end {
      justify-content: flex-end;
      margin-top: 5px;

      .md-button {
        box-shadow: unset;
        font-family: lato;
        font-size: 12px;
        font-weight: bold;
        border-radius: 3px;

        &.-export-selected {
          padding: 0 5px 0 5px;
          background-color: #d84710;
          //   background-color: #dedede;
          width: 175px;
          height: 32px;
          margin-left: 2px;
          margin-right: 2px;
        }

        &.-export-excel {
          padding: 0 5px 0 5px;
          height: 32px;
        }

        &.-import {
          margin-right: 0px;
          padding: 2px 5px 0 5px;
          width: 120px;
          height: 32px;

          .md-icon {
            font-size: 16px !important;
            margin-right: 5px;
            margin-top: 5px;
          }
        }

        .md-button-content {
          font-size: 12px;
        }
      }
    }

    .filter-chips {
      margin-top: 5px;
      margin-bottom: 5px;

      .tab-chip {
        padding-left: 10px;
        padding-right: 8px;
        border-radius: 35px;
        color: white;
        font-size: 12px;
        padding-top: 5px;
        padding-bottom: 5px;

        &.-primary {
          // background-color: #3F51B5;
          background-color: #3f7fb5;
          margin-right: 5px;
        }

        &.-delete {
          // background-color: #11258c;
          background-color: #1c64a0;
          padding-left: 4px;
          padding-right: 4px;
          padding-top: 2px;
          padding-bottom: 2px;
          margin-left: 3px;
          cursor: pointer;

          .material-icons {
            font-size: 11px;
          }
        }
      }
    }
  }

  #table-pricing-list,
  #table-bookprice-list {
    .md-checkbox {
      display: flex;
      margin-top: 0px;
      margin-bottom: 0px;
      padding-left: 0px !important;
    }

    #divHeadList {
      width: 99.3%;
      display: -webkit-inline-box;
      font-size: 13px;
      font-weight: bold;
      margin-top: 15px;
      margin-bottom: 15px;

      div {
        // border: 1px solid pink;
        padding-left: 3px;
        padding-right: 6px;

        &.-text-right {
          text-align: right;
        }

        &.-text-center {
          text-align: center;
        }
      }
    }

    #divBodyList {
      &.cal-height {
        height: calc(100vmin - 231px);
      }

      &.de-height {
        height: calc(100vmin - 263px);
      }

      width: 100%;
      display: block;
      overflow-y: scroll;
      font-size: 13px;

      > div {
        width: 100%;
        display: -webkit-inline-box;
        display: inline-block;
        padding-top: 6px;
        padding-bottom: 6px;

        #mainRows {
          font-weight: 400;
          color: #414141;
          font-family: lato;
          font-size: 13px;
          width: 100%;
          padding-left: 0px;
          display: flex;

          .-percent {
            color: #110af2;
            font-size: 11px;
          }

          .-bgred {
            font-size: 11px;
            color: #f44336;
          }
        }

        #childRows {
          width: 100%;
          padding-left: 0px;
          display: flex;
        }

        div {
          // border: 1px solid pink;
          padding-left: 3px;
          padding-right: 3px;

          &.-text-right {
            text-align: right;
          }

          &.-text-center {
            text-align: center;
          }

          &.nowrap-title {
            font-family: Kanit;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }

      &::-webkit-scrollbar {
        height: 7px;
        width: 5px;
      }
    }

    .main-row-bg-gray {
      border-radius: 4px;
      // background: rgba(245, 245, 245, 1);
      background: #3f51b52e;

      &.row-bg-gray:hover {
        background: rgba(236, 236, 235, 1) !important;
      }
    }
  }
}

/* DIALOG */
.pricinglist.dialog-import {
  font-family: lato;
  //   width: 70%;
  //   height: 80%;
  // z-index: 5;
  transform: unset !important;
  //   top: 10% !important;
  //   left: 15% !important;

  .-percent {
    color: #110af2;
    font-size: 11px;
  }

  .-bgred {
    font-size: 11px;
    color: #f44336;
  }

  .md-field .md-input-action {
    top: 15px;
  }

  &.md-dialog {
    max-height: unset;
  }

  &.-message {
    width: 35%;
    height: 55%;
    top: 25% !important;
    left: 35% !important;
    // z-index: 6;

    .dialog-content {
      padding-left: 20px;
    }
  }

  .row-bg-gray:hover {
    border-radius: 4px;
    background: rgba(236, 236, 235, 1);

    &.-file {
      // height: 35px;
      cursor: pointer;
    }
  }

  .row-bg-blue {
    border-radius: 4px;
    background: #e8f0fe;
    color: #005fd0;

    .-delete {
      color: #005fd0 !important;
    }
  }

  .md-dialog-title.md-title {
    margin-bottom: 5px;
  }

  .dialog-content {
    // padding: 20px;
    padding: 15px 5px 15px 25px;

    .mkt-datepicker {
      width: 100%;

      input {
        font-size: 14px;
      }
    }
  }

  .-layout-input {
    margin-top: 10px;
    margin-left: 5px;

    .md-field label {
      font-size: 14px;
    }

    .md-field.md-theme-default {
      margin-bottom: 10px;
    }
  }

  .-action {
    position: fixed;
    bottom: 0px;
    margin-right: auto;
    margin-left: auto;
    text-align: right;
    width: 100%;
    padding-right: 15px;

    .-cancel {
      color: #727272;
    }

    .-confirm {
      color: #3f51b5;
    }

    &.-error {
      justify-content: center !important;
    }
  }

  #table-import-file {
    width: 99% !important;
  }

  #table-pricing-list-import,
  #table-pricing-list-import-alert,
  #table-import-file {
    width: 100%;
    font-family: lato;

    .title-table {
      padding-left: 8px;
      font-family: lato;
      font-size: 18px;
      font-weight: bold;
      padding-bottom: 10px;
    }

    #divHeadFile {
      width: 99.5% !important;
      margin-bottom: 10px;
      margin-top: 20px;
    }

    #divHeadList,
    #divHeadListAlert,
    #divHeadFile {
      width: 99%;
      display: -webkit-inline-box;
      font-size: 13px;
      font-weight: bold;
      margin-top: 15px;
      margin-bottom: 15px;

      div {
        // border: 1px solid pink;
        padding-left: 3px;
        padding-right: 3px;

        &.-text-right {
          text-align: right;
        }

        &.-text-center {
          text-align: center;
        }

        &.-row-pd-right {
          padding-right: 20px;
        }
      }
    }

    #divBodyFile {
      height: calc(60vmin - 250px);
    }

    #divBodyList {
      height: calc(80vmin - 180px);
    }

    #divBodyListAlert {
      height: calc(70vmin - 170px);
      // height: calc(100vmin - 175px);
    }

    #divBodyList,
    #divBodyListAlert,
    #divBodyFile {
      // height: calc(100vmin - 280px);
      width: 100%;
      display: block;
      overflow-y: scroll;
      font-size: 13px;

      .percent-text {
        font-size: 10.5px;
      }

      > div {
        width: 100%;
        display: -webkit-inline-box;
        padding-top: 6px;
        padding-bottom: 6px;

        div {
          // border: 1px solid pink;
          padding-left: 3px;
          padding-right: 3px;

          &.-text-right {
            text-align: right;
          }

          &.-text-center {
            text-align: center;
          }

          &.nowrap-title {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          &.-row-pd-right {
            padding-right: 20px;
          }
        }
      }

      &::-webkit-scrollbar {
        height: 7px;
        width: 5px;
      }
    }
  }
}

.backdrop-pricing {
  background: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 7;
  top: 0;
  left: 0;
}

.loading-overlay-popup {
  z-index: 12;
  top: 0;
  left: 0;
  right: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
